// Simple i18n
const TRANSLATIONS = {
  pt: {
    app_name: "Intercar Manager",
    tagline: "Gestão completa para sua revenda",
    welcome_back: "Bem-vindo de volta",
    create_account_title: "Crie sua conta e revenda",
    auth_hero_line1: "Acelere",
    auth_hero_line2: "sua revenda",
    auth_hero_line3: "ao próximo nível.",
    auth_hero_blurb: "Estoque, vendas, leads, financeiro e equipe — tudo num só lugar, em tempo real.",
    auth_live_status: "Sistema online",
    auth_eyebrow_login: "Acesso restrito",
    auth_eyebrow_signup: "Nova conta",
    management_suite: "Suite de gestão",
    show: "Ver",
    hide: "Ocultar",
    or: "ou",
    dp_section: "Pagamento de Entrada",
    dp_fully_paid: "Entrada Quitada",
    dp_remaining: "Falta",
    dp_owes: "Falta",
    dp_entrance: "Entrada",
    dp_agreed: "Entrada Acordada",
    dp_paid_so_far: "Já Pago",
    dp_balance: "Restante",
    dp_history: "Histórico de Pagamentos",
    dp_no_payments: "Nenhum pagamento registrado ainda.",
    dp_add_payment: "Adicionar Pagamento",
    dp_view_history: "Ver Histórico",
    dp_amount: "Valor",
    dp_amount_required: "Informe um valor maior que zero",
    dp_payment_saved: "Pagamento registrado e recibo gerado!",
    dp_save_and_print: "Salvar e Imprimir Recibo",
    dp_notes_placeholder: "Ex: dinheiro vivo, cliente prometeu o resto sexta…",
    dp_all_paid_msg: "Cliente já quitou a entrada completa. Bom trabalho!",
    missing_purchase_singular: "1 carro sem preço de compra",
    missing_purchase_plural: "carros sem preço de compra",
    missing_purchase_hint: "— preencha para o fechamento ficar correto. As linhas em destaque estão sem este valor.",
    missing_purchase_row_hint: "Clique para preencher",
    select_option: "Selecione...",
    select_bank: "Selecione o banco...",
    reg_calc_title: "Calculadora MA",
    reg_calc_apply: "Usar",
    reg_calc_applied: "Aplicada",
    reg_calc_sale: "Preço de venda",
    reg_calc_trade_in: "Veículo na troca",
    reg_calc_taxable: "Base tributável",
    reg_calc_tax: "Sales tax (6,25%)",
    reg_calc_reg_fee: "Registration fee",
    reg_calc_title_fee: "Title fee",
    reg_calc_runner_fee: "Runner fee",
    reg_calc_total: "Total sugerido",
    funded: "Funded",
    not_funded: "Não",
    funded_marked: "FUNDED marcado — banco pagou a loja",
    funded_undone: "FUNDED removido",
    mark_funded: "Marcar FUNDED — banco pagou a loja",
    unmark_funded: "Desmarcar FUNDED",
    commission_blocked_until_funded: "Marque FUNDED primeiro — comissão só após o banco pagar",
    theme_auto: "Automático (segue a loja)",
    theme_auto_short: "Auto",
    theme_day: "Modo dia (claro)",
    theme_day_short: "Dia",
    theme_night: "Modo noite (escuro)",
    theme_night_short: "Noite",
    reg_in_price_label: "Incluir no preço do carro",
    reg_in_price_on_hint: "Loja absorveu o emplacamento → será lançado como despesa do veículo.",
    reg_in_price_off_hint: "Cliente paga separado → não conta como despesa (passthrough).",
    discount_label: "Desconto",
    discount_hint: "(opcional — abatido do preço final)",
    discount_applied_hint: "Desconto aplicado · subtraído do Preço Final Vendido",
    tasks: "Carros em Revisão",
    operations: "Operações",
    tasks_subtitle: "Atribua, lembre e acompanhe pendências do dia a dia",
    new_task: "Nova tarefa",
    edit_task: "Editar tarefa",
    task_title: "Título",
    task_title_placeholder: "Ex: Levar Honda Civic pra trocar pneu",
    task_title_required: "Título é obrigatório",
    task_description: "Detalhes",
    task_description_placeholder: "Descrição, endereço, peça, valor estimado...",
    task_assignee_required: "Atribua a pelo menos uma pessoa",
    task_test_email: "Testar email",
    task_test_email_tip: "Enviar email de teste para verificar o Resend",
    task_created_with_notify: "Tarefa criada e notificação enviada",
    due_at: "Prazo",
    priority: "Prioridade",
    linked_vehicle: "Veículo (opcional)",
    none: "Nenhum",
    assignees: "Atribuir a",
    assignees_notify_hint: "Cada pessoa receberá um email + notificação no app",
    open: "Abertas",
    overdue: "Atrasadas",
    done: "Concluídas",
    all: "Todas",
    no_tasks: "Nenhuma tarefa por aqui.",
    search_tasks: "Buscar tarefas...",
    mark_done: "Concluir",
    mark_undone: "Reabrir",
    customer_language: "Idioma do cliente",
    not_informed: "Não informado",
    full_name: "Nome completo",
    dealership_name: "Nome da revenda",
    email: "Email",
    password: "Senha",
    sign_in: "Entrar",
    create_account: "Criar conta",
    no_account: "Não tem conta? Criar conta",
    have_account: "Já tem conta? Entrar",
    dashboard: "Painel",
    inventory: "Estoque",
    sales: "Vendas",
    financials: "Financeiro",
    settings: "Configurações",
    sign_out: "Sair",
    overview: "Visão geral",
    total_vehicles: "Total de veículos",
    in_stock: "Em estoque",
    reserved: "Reservado",
    sold: "Vendido",
    on_display: "Em exposição",
    open_deals_title: "Negócios em andamento",
    open_deals_subtitle: "Vendidos · aguardando entrega",
    open_deals_empty: "Nenhum negócio em andamento.",
    pipeline_top_sellers_eyebrow: "Top vendedores",
    pipeline_month_revenue: "Receita do mês",
    pipeline_deals_closed_eyebrow: "Fechados",
    pipeline_deals_closed: "fechados",
    pipeline_deal: "deal",
    pipeline_deals: "deals",
    pipeline_leaderboard_empty: "Nenhuma venda fechada esse mês ainda.",
    pipeline_velocity_eyebrow: "Pulso de vendas",
    pipeline_velocity_title: "Últimos 14 dias",
    pipeline_this_week: "Esta semana",
    pipeline_vs_prev_week: "vs sem anterior",
    pipeline_today: "Hoje",
    pipeline_week_revenue: "Receita 7d",
    pipeline_open_deals_short: "Em aberto",
    pipeline_prev_week: "Semana anterior",
    pipeline_kpi_open_deals: "Negócios abertos",
    pipeline_kpi_revenue: "Receita prevista",
    pipeline_kpi_entrada_paid: "Entradas recebidas",
    pipeline_kpi_entrada_due: "Entradas a receber",
    deal_days_open_hint: "Dias desde a venda",
    deal_stale_hint: "Negócio parado há muito tempo — cobre status do vendedor ou ligue pro banco",
    pipeline_kpi_stale: "Parados >20d",
    stale_kpi_hint: "Clique para filtrar",
    stale_filter_active: "Filtro ativo",
    stale_filter_label: "Filtrar:",
    stale_filter_all: "Todos",
    stale_filter_20: "Parados >20d",
    stale_filter_30: "Críticos >30d",
    stale_view_20: "Negócios parados há mais de 20 dias",
    stale_view_30: "Negócios críticos · mais de 30 dias parados",
    stale_empty_good_news: "Boas notícias! Nenhum deal parado nesse intervalo.",
    clear_filters: "Limpar",
    commission_paid: "Paga",
    commission_pending: "Pendente",
    available: "Disponível",
    delivery_view_active: "Ativos",
    delivery_view_delivered: "Entregues",
    delivered_this_month: "Entregues no mês",
    avg_delivery_days: "Tempo médio (dias)",
    pending_deliveries: "Pendentes",
    post_sales_from_delivered: "Ticket de carro entregue",
    post_sales_pick_delivered_title: "Selecione o carro entregue",
    post_sales_pick_delivered_subtitle: "Clique no carro e o ticket é criado com os dados preenchidos.",
    post_sales_no_delivered: "Nenhum carro entregue ainda.",
    invested: "Investido em estoque",
    revenue: "Faturamento total",
    profit: "Lucro total",
    avg_ticket: "Ticket médio",
    monthly_performance: "Performance mensal",
    months_short: "meses",
    leads_title: "Leads",
    leads_count_label: "leads",
    unassigned_label: "Sem vendedor",
    my_leads: "Meus leads",
    assigned: "Atribuído",
    add_lead: "Adicionar lead",
    edit_lead: "Editar lead",
    no_leads: "Nenhum lead nessa visão.",
    search_lead: "Buscar nome, telefone, email...",
    contact: "Contato",
    last_contact: "Último contato",
    interest_make_model: "Carro de interesse",
    budget: "Orçamento",
    payment_type: "Forma de pagamento",
    payment_cash: "À vista",
    payment_financing: "Financiamento",
    claim_lead: "Pegar este lead",
    lead_claimed: "Lead atribuído a você!",
    import_monday: "Importar do Monday",
    confirm_monday_import: "Importar/atualizar leads do Monday agora?",
    imported: "Importados",
    updated: "Atualizados",
    total: "Total",
    bdc_users_title: "Usuários BDC",
    bdc_users_hint: "BDC só vê o painel e a aba Leads. Cria, edita e atribui leads aos vendedores.",
    add_bdc: "Adicionar BDC",
    no_bdc_users: "Nenhum BDC cadastrado ainda.",
    team_title: "Equipe",
    team_hint: "Adicione vendedores e BDCs e escolha exatamente o que cada um pode ver no sistema.",
    add_team_member: "Adicionar pessoa",
    edit_team_member: "Editar pessoa",
    no_team_members: "Nenhuma pessoa cadastrada ainda.",
    role: "Cargo",
    permissions_label: "Permissões",
    permissions_hint: "Marque as áreas que essa pessoa pode acessar. Você pode mudar isso a qualquer momento.",
    link_salesperson: "Vincular ao vendedor cadastrado",
    select_salesperson: "Selecione um vendedor",
    no_available_salesperson: "Todos vendedores já têm login. Crie um novo vendedor primeiro na aba Vendedores.",
    must_pick_salesperson: "Selecione qual vendedor terá esse login.",
    leave_blank_to_keep: "deixe em branco pra manter",
    change_photo: "Trocar foto",
    team_photo_hint: "Clique na foto pra enviar uma imagem do computador (opcional).",
    owner_role: "Dono",
    owner_role_hint: "Dono tem acesso total — não precisa marcar permissões.",
    owner_full_access_note: "Acesso total — vê tudo no sistema.",
    self_badge: "(você)",
    manager: "Gerente",
    general_role: "Geral",
    fi_role: "F&I",
    lead_status_new: "Novo",
    lead_status_in_progress: "Em progresso",
    lead_status_hot_lead: "Hot lead",
    lead_status_follow_up: "Follow-up",
    lead_status_cold: "Frio",
    lead_status_no_answer: "Não atendeu",
    lead_status_wrong_number: "Número errado",
    lead_status_deal_closed: "Fechou",
    lead_status_lost: "Perdido",
    lead_status_future: "Futuro",
    lead_source_facebook: "Facebook",
    lead_source_instagram: "Instagram",
    lead_source_google_ads: "Google Ads",
    lead_source_cargurus: "CarGurus",
    lead_source_carfax: "Carfax",
    lead_source_craigslist: "Craigslist",
    lead_source_walk_in: "Walking",
    lead_source_referral: "Indicação",
    lead_source_phone: "Telefone",
    lead_source_bdc: "BDC",
    lead_source_whatsapp: "WhatsApp",
    lead_source_marketplace: "Marketplace",
    lead_source_tiktok: "TikTok",
    lead_source_youtube: "YouTube",
    lead_source_repeat_customer: "Cliente antigo",
    lead_source_website: "Site próprio",
    lead_source_unknown: "Não informado",
    lead_source_other: "Outro",
    lead_source_label: "Como o cliente chegou até a loja?",
    lead_source_hint: "Nos ajuda a saber qual estratégia de venda está funcionando melhor.",
    lead_source_panel_title: "Origem das vendas",
    lead_source_panel_hint: "De onde chegaram os clientes que fecharam esse mês.",
    lead_source_panel_empty: "Sem vendas com origem informada neste mês.",
    lead_source_top_channel: "Canal top",
    leaderboard_title: "Ranking de vendedores · este mês",
    leaderboard_empty: "Ainda sem vendas neste mês.",
    leaderboard_others: "Demais vendedores",
    vendedor_do_mes: "VENDEDOR DO MÊS",
    weekly_promo_title: "Promoção da semana",
    no_promotion: "Sem promoção ativa.",
    create_promotion: "Criar promoção",
    promo_image: "Imagem",
    upload_image: "Enviar imagem",
    promo_title_placeholder: "Ex: Sexta-feira de descontos",
    promo_desc_placeholder: "Detalhe da promoção, valores, condições...",
    valid_until: "Válida até",
    optional: "opcional",
    title: "Título",
    description: "Descrição",
    add_vehicle: "Adicionar veículo",
    import_from_url: "Importar pela URL",
    paste_url: "Cole a URL do carro no seu site",
    import: "Importar",
    importing: "Importando...",
    import_success: "Dados importados! Revise e salve.",
    import_failed: "Não consegui importar dessa URL.",
    edit: "Editar",
    delete: "Excluir",
    save: "Salvar",
    cancel: "Cancelar",
    search: "Buscar...",
    make: "Marca",
    model: "Modelo",
    year: "Ano",
    color: "Cor",
    vin: "VIN Number",
    purchase_price: "Preço de compra",
    sale_price: "Preço de venda",
    expenses: "Despesas",
    expenses_total: "Total de gastos",
    expense_items: "Gastos detalhados",
    add_expense: "Adicionar gasto",
    expense_description: "Descrição do gasto",
    expense_amount: "Valor",
    expense_category: "Categoria",
    expense_date: "Data",
    expense_attachments: "Notas/comprovantes",
    expense_no_items: "Nenhum gasto registrado ainda. Adicione o primeiro!",
    cat_parts: "Peças",
    cat_labor: "Mão de obra",
    cat_paint: "Pintura/funilaria",
    cat_documentation: "Documentação",
    cat_transport: "Transporte/guincho",
    cat_detail: "Limpeza/detalhamento",
    cat_inspection: "Vistoria/inspeção",
    cat_other: "Outros",
    real_profit: "Lucro real estimado",
    upload_invoice: "Anexar nota fiscal/foto",
    salespeople: "Vendedores",
    salesperson: "Vendedor",
    select_salesperson: "Selecione o vendedor",
    add_salesperson: "Adicionar vendedor",
    salesperson_name: "Nome",
    commission_amount: "Comissão (US$)",
    commission_paid: "Pago",
    commission_pending: "Pendente",
    mark_paid: "Marcar como pago",
    mark_unpaid: "Marcar como pendente",
    paid: "Pago",
    pending: "Pendente",
    phone: "Telefone",
    active: "Ativo",
    inactive: "Inativo",
    no_salespeople: "Nenhum vendedor cadastrado.",
    financial: "Financeiro",
    financial_dashboard: "Dashboard financeiro",
    monthly_closing: "Fechamento do mês",
    gross_profit: "Lucro dos carros",
    operational_expenses: "Despesas operacionais",
    operational_total: "Total despesas",
    paid_commissions: "Comissões pagas",
    net_profit: "Lucro líquido",
    cars_sold_in_month: "Carros vendidos no mês",
    all_sold_cars: "Todos os carros vendidos",
    buyer_dob: "Aniversário do cliente",
    notif_birthdays: "Aniversários de clientes",
    notif_assigned_leads: "Leads direcionados pra você",
    notif_stale_leads: "Leads sem resposta do vendedor (+24h)",
    no_response_label: "sem resposta",
    daily_summary_btn: "Resumo do dia",
    inventory_search_placeholder: "Buscar carro, VIN, placa, ano ou cliente...",
    rec_search_placeholder: "Buscar por cliente, telefone, carro ou VIN...",
    sold_search_placeholder: "Buscar por nome do cliente, VIN ou carro...",
    results_label: "resultado(s)",
    sold_search_empty: "Nenhuma venda encontrada pra essa busca",
    view_expenses: "Ver gastos",
    revert_to_stock: "Voltar ao estoque",
    revert_sale_hint: "Cliente desistiu? Volte o carro pro estoque limpando os dados de venda (comprador, preço de venda, vendedor, comissão, entrega).",
    confirm_revert_sale: "Tem certeza? O carro vai voltar pro estoque e os dados de venda (comprador, vendedor, comissão, etapa de entrega) serão apagados. As despesas e o preço de compra serão mantidos.",
    returned_to_stock: "Carro devolvido ao estoque!",
    lost_sale_title: "Por que a venda caiu?",
    lost_sale_hint: "Selecione o motivo. Isso entra no relatório do Financeiro pra você acompanhar perdas.",
    lost_reason: "Motivo",
    notes: "Observação",
    lost_notes_placeholder: "Detalhe extra (opcional)",
    confirm: "Confirmar",
    lost_sales_title: "Vendas que caíram",
    lost_revenue: "Receita perdida",
    reason_financing_denied: "Reprovado no financiamento",
    reason_client_changed_mind: "Cliente desistiu",
    reason_mechanical_issue: "Problema mecânico",
    reason_price_disagreement: "Não fechou o preço",
    reason_found_better_deal: "Achou melhor opção",
    reason_other: "Outro",
    add_expense: "Adicionar despesa",
    expense_date: "Data",
    expense_category: "Categoria",
    expense_description: "Descrição",
    expense_amount: "Valor",
    expense_attachment: "Nota fiscal",
    no_expenses: "Nenhuma despesa lançada neste mês.",
    cat_rent: "Aluguel",
    cat_water: "Água",
    cat_electricity: "Luz",
    cat_internet: "Internet",
    cat_phone: "Telefone",
    cat_salary: "Salários",
    cat_marketing: "Marketing",
    cat_maintenance: "Manutenção/Limpeza",
    cat_taxes: "Impostos",
    cat_floor_plan: "Floor Plan",
    cat_post_sale: "Pós-venda",
    cat_fi_commission: "Comissão F&I",
    cat_other: "Outros",
    operational_credits: "Créditos operacionais",
    add_credit: "Adicionar crédito",
    edit_credit: "Editar crédito",
    no_credits: "Nenhum crédito neste mês.",
    net_operational: "Líquido operacional",
    credit_cat_sublease: "Sublocação",
    credit_cat_refund: "Reembolso",
    credit_cat_commission: "Comissão recebida",
    credit_cat_other: "Outros créditos",
    credit_cat_receivable_payment: "Recebível",
    credit_auto: "Auto",
    credit_auto_tooltip: "Crédito gerado automaticamente por uma parcela paga em Recebíveis",
    credit_managed_in_receivables: "Em Recebíveis",
    // Receivables
    receivables_tab: "Recebíveis",
    receivables_title: "Recebíveis",
    receivables_eyebrow: "Cobranças e parcelamentos",
    rec_add: "Novo recebível",
    rec_edit: "Editar recebível",
    rec_vehicle: "Veículo",
    rec_pick_vehicle: "Escolha um veículo",
    rec_no_vehicle: "Sem veículo (cliente avulso)",
    rec_no_vehicle_short: "Cliente avulso",
    rec_print_schedule: "Imprimir cronograma para o cliente",
    rec_freq_change_warning: "As datas das parcelas pendentes serão recalculadas com a nova frequência. As já pagas ficam intactas.",
    rec_installment_amount_hint: "Aplicado às parcelas ainda pendentes. As já pagas ficam intactas.",
    // ---------- Defer to next month ----------
    defer_col_hint: "Adiar para o próximo mês",
    move_store_btn: "Trocar loja do carro (vendedor continua o mesmo)",
    move_store_title: "Mover fechamento para",
    move_store_keep_seller: "O vendedor continua o mesmo — só muda a loja onde o carro conta no fechamento (recibos e recebíveis vão junto).",
    move_store_done: "Carro movido — vendedor mantido",
    fund_override_confirm: "Você é o DONO — liberar o FUNDED mesmo assim? (ex.: entrada parcelada direto com o cliente — ficará registrado no histórico)",
    defer_to_next_month_tooltip: "Adiar este carro para o fechamento do próximo mês",
    defer_undo_tooltip: "Trazer este carro de volta para este mês",
    defer_confirm: "Adiar este carro para o próximo fechamento? Ele sai do mês atual (lucro, comissões e comissão F&I).",
    defer_undo_confirm: "Trazer este carro de volta para o mês atual?",
    defer_done: "Carro adiado para o próximo mês",
    defer_undone: "Carro restaurado para o mês atual",
    deferred_to_label: "Adiado para",
    delivered_in_month_label: "Entregue em",
    delivered_auto_migrate_hint: "Migrou automaticamente para o mês de entrega",
    delivered_label: "Entregue",
    delivered_on: "Entregue em",
    // ---------- F&I Officer ----------
    fi_title: "F&I Officer (Finanças & Seguros)",
    fi_subtitle: "Cadastre o responsável pelo fechamento dos financiamentos. O sistema lança automaticamente uma despesa de comissão a cada carro que vira FUNDED.",
    fi_photo: "Foto",
    fi_photo_uploaded: "Foto atualizada",
    fi_name: "Nome completo",
    fi_name_placeholder: "Ex: John Smith",
    fi_weekly_salary: "Salário semanal (US$)",
    fi_commission_per_funded: "Comissão por carro funded (US$)",
    fi_pay_weekly: "Pagar salário desta semana",
    fi_week_already_paid: "Semana atual já paga",
    fi_remove: "Remover F&I",
    fi_remove_confirm: "Remover o cadastro do F&I? As despesas já lançadas continuam no histórico.",
    fi_legal_note: "A comissão é lançada como despesa operacional automaticamente quando um carro é marcado como FUNDED. Se você des-fundar o carro, a despesa é removida.",
    fi_month_commissions: "Comissões neste mês",
    fi_this_week_salary: "Salário desta semana",
    fi_last_paid: "Último salário pago",
    fi_paid: "PAGO",
    fi_pending: "PENDENTE",
    fi_already_paid_week: "Salário desta semana já havia sido pago",
    fi_salary_paid: "Salário registrado no Financeiro",
    removed: "Removido",
    payment_auth_btn: "Autorização de Pagamento",
    payment_auth_pick_lang: "Idioma do documento",
    rec_customer_name: "Nome do cliente",
    rec_customer_required: "Nome do cliente é obrigatório",
    rec_phone: "Telefone",
    rec_total_amount: "Valor total",
    rec_down_payment: "Entrada (opcional)",
    rec_down_payment_short: "Entrada",
    rec_down_payment_hint: "Pago no ato. Reduz o valor parcelado.",
    rec_down_payment_receipt: "Recibo da entrada",
    purchase_agreement: "Contrato de Venda",
    forgot_password: "Esqueci minha senha",
    forgot_title: "Recuperar senha",
    forgot_hint: "Digite seu email e enviaremos um link para redefinir sua senha.",
    forgot_send: "Enviar link",
    forgot_sent: "Se o email existir, você receberá o link de redefinição em instantes. Confira também a caixa de spam.",
    back_to_login: "Voltar pro login",
    reset_title: "Nova senha",
    reset_hint: "Escolha uma nova senha para sua conta.",
    new_password_label: "Nova senha",
    confirm_password_label: "Confirmar senha",
    reset_submit: "Redefinir senha",
    reset_success: "Senha redefinida! Faça login com a nova senha.",
    reset_invalid: "Link inválido ou expirado. Peça um novo link.",
    passwords_dont_match: "As senhas não conferem",
    password_min: "A senha precisa de pelo menos 6 caracteres",
    notif_title: "Notificações",
    diag_title: "Diagnóstico da conta",
    test_email_btn: "Enviar email de teste",
    net_check_label: "Net check (financiamento)",
    send_closing_email: "Enviar fechamento por email",
    negotiation_sheet_ready: "Ficha de negociação finalizada",
    open_sheet: "Abrir ficha",
    resend_sale_email: "Reenviar email de venda",
    diag_healthy: "Tudo certo! Nenhum problema encontrado nesta conta.",
    diag_repair: "Reparar automaticamente",
    diag_repaired: "Conta reparada!",
    diag_fix_note: "Itens em vermelho sem reparo automático: recrie as credenciais em Equipe ou peça pra pessoa tentar de novo.",
    diag_check_login: "Login e senha cadastrados",
    diag_check_store: "Loja do usuário",
    diag_check_group: "Vínculo com o grupo de lojas",
    diag_check_permissions: "Permissões de acesso",
    diag_check_sp_link: "Vínculo com cadastro de vendedor",
    diag_check_sp_store: "Loja do login = loja do vendedor",
    diag_check_duplicates: "Contas duplicadas",
    nav_delivery: "Entregas",
    notif_empty: "Tudo em dia! Nenhum alerta pendente.",
    notif_rmv: "RMV pendente",
    notif_stuck: "Entregas paradas +45d",
    notif_overdue: "Cobranças atrasadas",
    notif_due_today: "Cobranças vencem hoje",
    notif_revision_ready: "Prontos na revisão",
    notif_new_leads: "Leads novos",
    activity_tab: "Atividades",
    activity_title: "Log de Atividades",
    activity_hint: "Quem fez o quê e quando — ações importantes das suas lojas.",
    activity_empty: "Nenhuma atividade registrada ainda.",
    activity_load_more: "Carregar mais",
    activity_search: "Buscar por usuário, ação ou item...",
    act_vehicle_deleted: "excluiu o carro",
    act_vehicle_transferred: "transferiu o carro",
    act_vehicle_funded: "marcou FUNDED:",
    act_vehicle_unfunded: "desmarcou FUNDED:",
    act_sale_corrected: "corrigiu valores de venda:",
    act_expense_created: "lançou a despesa",
    act_expense_deleted: "excluiu a despesa",
    act_receivable_deleted: "excluiu a cobrança de",
    act_team_member_deleted: "removeu da equipe:",
    act_salesperson_transferred: "transferiu o vendedor",
    bank_other_option: "Outro banco (digitar)...",
    bank_other_placeholder: "Digite o nome do banco novo...",
    finance_term: "Qtd. de parcelas",
    finance_installment: "Valor da parcela (US$)",
    warranty_months_label: "Garantia (meses)",
    payment_frequency_label: "Frequência do pagamento",
    freq_monthly: "Mensal",
    freq_weekly: "Semanal",
    doc_fee_included: "DOC FEE US$ 499.00 — incluído em todo financiamento (sai especificado no contrato)",
    doc_fee_charge: "Cobrar Doc Fee (US$ 499.00)",
    doc_fee_hint: "Escolha se o doc fee será cobrado nessa venda à vista — sai direto no contrato.",
    doc_fee_yes: "Cobrar US$ 499",
    doc_fee_no: "Não cobrar (desconto)",
    doc_fee_mandatory: "Obrigatório em todo financiamento — sai automático no contrato.",
    contract_edit_title: "Contrato de Venda — conferir antes de imprimir",
    contract_edit_hint: "As alterações feitas aqui valem SOMENTE para este PDF — não mudam o fechamento nem os dados do carro.",
    contract_generate: "Gerar PDF do contrato",
    rate_label: "Taxa (Rate %)",
    referral_label: "Referral / Origem",
    trade_in_title: "Veículo na troca",
    trade_in_value: "Avaliação",
    payoff: "Payoff",
    payoff_bank: "Banco do payoff",
    vex_fix_values: "Corrigir valores (só dono)",
    vex_fix_save: "Salvar correção",
    vex_fix_saved: "Valores corrigidos",
    vex_fix_hint: "Correção do dono: ajusta direto o fechamento. Fica registrado no histórico do carro.",
    rec_down_payment_paid_on: "Entrada paga em",
    rec_total: "Total",
    rec_paid: "Pago",
    rec_remaining: "Falta",
    rec_frequency: "Frequência",
    rec_freq_weekly: "Semanal",
    rec_freq_biweekly: "Quinzenal",
    rec_freq_monthly: "Mensal",
    rec_installment_count: "Nº de parcelas",
    rec_installment_amount: "Valor da parcela",
    rec_installments: "parcelas",
    rec_start_date: "Data 1ª parcela",
    rec_due_date: "Vencimento",
    rec_amount: "Valor",
    rec_status: "Situação",
    rec_status_active: "Ativo",
    rec_status_completed: "Quitado",
    rec_status_cancelled: "Cancelado",
    rec_filter_all: "Todos",
    rec_paid_at: "Pago em",
    rec_paid_label: "Pago",
    rec_pending: "Pendente",
    rec_mark_paid: "Marcar pago",
    rec_marked_paid: "Parcela paga!",
    rec_undo_paid: "Desfazer",
    rec_confirm_unpay: "Tem certeza que quer reverter este pagamento?",
    rec_total_remaining: "Total a receber",
    rec_overdue: "Atrasadas",
    rec_due_today: "Vence hoje",
    rec_due_week: "Próx. 7 dias",
    rec_paid_this_month: "Recebido no mês",
    rec_reminders: "Lembretes de cobrança",
    rec_empty: "Nenhum recebível cadastrado.",
    rec_notes: "Observações",
    rec_preview_schedule: "Prévia das parcelas",
    rec_more: "mais",
    rec_overview_card: "A receber",
    rec_overview_overdue: "atrasadas",
    rec_edit_due_date: "Editar data",
    rec_edit_propagate: "Aplicar para próximas",
    delivered_archive_eyebrow: "Histórico de entregas",
    delivered_archive_title: "Vendidos & Entregues",
    delivered_archive_count: "carros entregues",
    delivered_archive_current: "Mês atual",
    delivered_trend_title: "Entregas · Últimos 6 meses",
    delivered_trend_vs_prev: "vs. mês anterior",
    delivered_archive_export_pdf: "Exportar PDF do mês",
    expand: "Expandir",
    collapse: "Recolher",
    // Sale finalization (sold modal)
    mark_as_sold: "Marcar como vendido",
    sale_finalize: "Finalizar venda",
    sale_breakdown: "Detalhamento do recebimento",
    down_payment: "Entrada",
    bank_check_amount: "Cheque do banco",
    registration_cost: "Emplacamento",
    registration_cost_hint: "Quanto você vai gastar para registrar/emplacar este carro",
    final_sold_price: "Valor da venda",
    asking_price: "Preço pedido",
    difference: "Diferença",
    over_asking: "acima do pedido",
    under_asking: "abaixo do pedido",
    cat_registration: "Emplacamento",
    rec_reminder_title: "Lembrete de cobrança",
    rec_alert_dismiss: "OK, ver depois",
    rec_alert_open: "Ver recebíveis",
    push_enabled: "Notificações ativadas!",
    push_disabled: "Notificações desativadas.",
    push_enable_hint: "Receber alertas no celular quando vender um carro",
    push_disable_hint: "Desativar notificações no celular",
    push_permission_denied: "Permissão negada. Habilite nas configurações do navegador.",
    push_not_supported: "Seu navegador não suporta notificações push.",
    select_month: "Selecione o mês",
    set_login: "Definir login",
    edit_login: "Editar login",
    revoke_login: "Remover login",
    has_login: "Tem login",
    no_login: "Sem login",
    login_email: "Email de login",
    new_password: "Nova senha",
    salesperson_login_hint: "O vendedor poderá entrar com esse email e senha. Ele NÃO verá quanto você pagou no carro nem o lucro.",
    confirm_revoke_login: "Remover o login deste vendedor? Ele não conseguirá mais acessar o app.",
    sales_report: "Relatório de vendas",
    period: "Período",
    all_time: "Todo período",
    this_month: "Este mês",
    last_month: "Mês passado",
    by_salesperson: "Por vendedor",
    detailed_sales: "Vendas detalhadas",
    sales_count: "Vendas",
    total_revenue: "Receita total",
    total_commission: "Comissão total",
    day_of_month: "Dia",
    sale_date: "Data da venda",
    unassigned: "Sem vendedor",
    change_salesperson: "Trocar vendedor",
    description: "Descrição",
    images: "Fotos do veículo",
    status: "Status",
    transmission: "Câmbio",
    fuel_type: "Combustível",
    body_type: "Carroceria",
    buyer_name: "Nome do comprador",
    buyer_phone: "Telefone do comprador",
    buyer_email: "Email do comprador",
    buyer_address: "Endereço do comprador",
    payment_method: "Forma de pagamento",
    sold_price: "Preço final vendido",
    no_vehicles: "Nenhum veículo cadastrado ainda.",
    confirm_delete: "Confirma a exclusão?",
    public_api: "API pública",
    api_description: "Use este endpoint no seu site externo para puxar o estoque automaticamente.",
    api_token: "Token da API",
    regenerate: "Gerar novo token",
    copy: "Copiar",
    copied: "Copiado!",
    profit_per_vehicle: "Lucro por veículo",
    cost: "Custo",
    sold_at: "Vendido em",
    move_to: "Mover para",
    saved: "Salvo!",
    error_generic: "Algo deu errado.",
    invalid_credentials: "Email ou senha inválidos",
    email_in_use: "Email já cadastrado",
    pipeline: "Esteira de vendas",
    finalize_sale: "Finalizar venda",
    delivery: "Esteira de entrega",
    delivery_pipeline_title: "Esteira de Veículos",
    edit_step: "Editar etapa",
    advance_step: "Avançar etapa",
    back_step: "Voltar etapa",
    notes: "Notas",
    bank: "Banco",
    delivery_notes: "Notas da entrega",
    no_deliveries: "Nenhum veículo em entrega no momento.",
    delivered_section_title: "Já entregues",
    delivered_section_one: "carro entregue",
    delivered_section_many: "carros entregues",
    delivered_label: "Entregue",
    reopen_delivery: "Reabrir entrega",
    reopen_delivery_confirm: "Reabrir esta entrega? O carro voltará para a etapa 7 (Registro) e a data de entrega será limpa.",
    delivery_reopened: "Entrega reaberta — carro voltou para a etapa 7",
    reopen_delivery: "Reabrir entrega",
    reopen_delivery_confirm: "Reabrir esta entrega? O carro voltará para a etapa 7 (Registro) e a data de entrega será limpa.",
    delivery_reopened: "Entrega reaberta — carro voltou para a etapa 7",
    no_stuck_deliveries: "Nenhum carro parado no momento.",
    stuck_alert_title_one: "carro parado há mais de 45 dias",
    stuck_alert_title_many: "carros parados há mais de 45 dias",
    stuck_alert_hint: "Dá uma olhada — alguma etapa travou e precisa destravar pra entregar.",
    stuck_days_chip: "Parado há {d} dias",
    show_only_stuck: "Ver só os parados",
    show_all: "Ver todos",
    step_1: "Vendido",
    step_2: "Ficha de negociação + Recibo",
    bank_contract_short: "Contrato",
    bank_contract_signed_on: "Contrato do banco assinado",
    bank_contract_pending: "Marcar contrato do banco como assinado",
    bank_contract_marked: "Contrato marcado como assinado!",
    bank_contract_unmarked: "Marca de contrato removida.",
    // Receipts (deposit receipts)
    receipts: "Recibos",
    new_receipt: "Novo recibo",
    no_receipts_yet: "Nenhum recibo emitido ainda.",
    receipt_amount: "Valor do depósito",
    receipt_amount_required: "Informe o valor do depósito",
    receipt_created: "Recibo criado!",
    non_refundable_amount: "Valor não-reembolsável",
    create_and_print: "Criar e imprimir",
    address: "Endereço",
    open_pdf: "Abrir PDF",
    step_3: "Documentações",
    doc_drive: "Carteira de Motorista",
    doc_insurance: "Seguro",
    doc_income: "Comprovante de Renda",
    doc_address: "Comprovante de Endereço",
    doc_other: "Outros documentos",
    doc_uploaded: "documento(s)",
    doc_no_files_yet: "Nenhum arquivo aqui ainda — clique pra adicionar.",
    doc_add_file: "Adicionar arquivo",
    // Parts notes block on the Overview dashboard
    parts_notes_title: "Peças a Comprar",
    parts_notes_eyebrow: "Bloco de Notas",
    parts_notes_subtitle: "Anote as peças que precisa comprar e os lembretes da oficina",
    parts_notes_scratch_label: "Anotações",
    parts_notes_scratch_placeholder: "Escreva livremente aqui — códigos de peça, fornecedores, avisos, etc.",
    parts_notes_list_label: "Lista de peças",
    parts_notes_list_placeholder: "Ex: Pastilha de freio dianteira · Civic 2018",
    parts_notes_add: "Adicionar peça",
    parts_notes_empty: "Sem itens ainda. Adicione a primeira peça acima.",
    parts_notes_pending: "pendente(s)",
    parts_notes_done: "concluída(s)",
    parts_notes_save: "Salvar anotações",
    parts_notes_saved: "Anotações salvas",
    parts_notes_last_update: "Atualizado por",
    parts_notes_manager_only: "Somente gerentes podem editar",
    // Revision status badge on delivery cards
    revision_badge_in_shop: "REVISÃO: EM OFICINA",
    revision_badge_ready: "REVISÃO: PRONTA",
    revision_badge_pending: "REVISÃO: AGUARDANDO",
    // WhatsApp quick-contact messages (wa.me deep-link)
    wa_button_label: "WhatsApp",
    wa_delivery_message: "Olá {name}! Passando pra te atualizar sobre o seu {vehicle}. Ele está agora na etapa: {step}. Qualquer dúvida é só me avisar.",
    wa_revision_ready_message: "Olá {name}! Boa notícia: o seu {vehicle} acabou de sair da revisão e está pronto pra retirada. Combinamos um horário?",
    wa_delivered_message: "Olá {name}! Obrigado pela confiança em levar o {vehicle} com a gente. Qualquer coisa que precisar, é só chamar aqui.",
    vex_add_post_sale: "Adicionar despesa pós-venda",
    post_sale_desc_placeholder: "Ex: Troca de pastilha de freio",
    step_4: "Manutenção",
    step_5: "Seguro",
    step_6: "Título recebido",
    step_7: "Registro",
    step_8: "Entregue",
    save_step: "Salvar etapa",
    bank_name_label: "Nome do banco",
    delivered: "Entregue",
    in_progress: "Em andamento",
    no_photo: "Sem foto",
    files: "Arquivos",
    upload_file: "Enviar arquivo",
    upload_for_step: "Anexar arquivos · Etapa",
    drag_drop: "Arraste arquivos aqui ou clique para selecionar",
    no_files_yet: "Nenhum arquivo nesta etapa ainda.",
    file_too_large: "Arquivo muito grande (máx 20MB)",
    download: "Baixar",
    view: "Ver",
    step_notes_label: "Notas desta etapa",
    step_notes_placeholder: "Ex: Cliente pediu troca de pastilha de freio e revisão dos pneus...",
    save_notes: "Salvar notas",
    delivery_photos: "Fotos da entrega",
    delivery_photos_hint: "Suba todas as fotos do carro no momento da entrega ao cliente (estado externo, interno, hodômetro, documentos, etc.). Sem limite de quantidade.",
    photos_count: "fotos",
    photos_imported: "fotos importadas — todas serão salvas",
    vehicle_history: "Histórico",
    close_month_btn: "Fechar mês",
    close_month_title: "Fechar e exportar",
    close_month_intro: "O fechamento conta apenas carros já FUNDADOS pelo banco no mês. Vendas sem funding ficam em aberto e entram no próximo mês.",
    closing_funded_vehicles: "Veículos fundados",
    credits_total: "Créditos operacionais",
    closing_receivables_received: "Recebíveis recebidos",
    purchase_missing_badge: "Sem preço",
    purchase_missing_hint: "Preço de compra não preenchido — o lucro real está superestimado. Clique no valor pra editar.",
    purchase_missing_count: "sem preço de compra",
    notifications_title: "Notificações por email",
    notifications_description: "Receba um aviso curto no seu email sempre que um evento importante acontecer. Vai pra você (dono) e todos os gerentes da loja.",
    notifications_team_events_title: "Notificar a equipe",
    notifications_team_events_hint: "Quando ativo, dispara emails diretos pra você e os gerentes a cada evento abaixo:",
    notifications_status_on: "Notificações ativadas",
    notifications_status_off: "Notificações desativadas",
    notif_event_sold: "Carro vendido",
    notif_event_funded: "Carro fundado pelo banco",
    notif_event_delivered: "Carro entregue ao cliente",
    notif_event_application: "Nova aplicação de crédito",
    notif_event_down_payment: "Entrada (down payment) registrada",
    notif_event_installment: "Parcela de recebível paga",
    notif_event_lead: "Novo lead cadastrado",
    fp_inventory_eyebrow: "Localização rápida",
    fp_inventory_title: "Estoque por Floor Plan",
    fp_inventory_units: "carros financiados",
    fp_inventory_title_pending: "title pendentes",
    fp_inventory_title_pending_short: "title",
    fp_inventory_title_pending_section: "Title pendente · vendidos sem funding",
    fp_inventory_on_lot_section: "No estoque",
    fp_inventory_search_placeholder: "Buscar por carro, VIN, comprador, stock #...",
    fp_inventory_no_plans: "Cadastre um floor plan primeiro pra começar a organizar o estoque.",
    fp_inventory_no_matches: "Nenhum carro encontrado nessa busca.",
    fp_inventory_empty_plan: "Nenhum carro vinculado a este floor plan ainda.",
    fp_inventory_orphans_title: "Sem floor plan",
    fp_inventory_orphans_hint: "carros sem nenhum pagamento vinculado",
    fp_on_lot_short: "no estoque",
    fp_pending_short: "title pend.",
    floor_plan_label: "Floor Plan",
    floor_plan_hint: "de onde veio o carro (pra pedir o title)",
    floor_plan_none: "Sem floor plan",
    floor_plan_no_plans_hint: "Cadastre um floor plan na aba Financeiro → Floor Plans.",
    closing_open_deals_title: "Negócios em aberto",
    closing_open_deals_hint: "Estes carros foram vendidos mas o banco ainda não fundou — eles vão entrar no próximo fechamento mensal automaticamente.",
    close_month_success: "Mês fechado e PDF baixado!",
    close_and_export: "Fechar e baixar PDF",
    closings_archive_title: "Pasta de fechamentos",
    closings_archive_empty: "Nenhum mês fechado ainda. Use o botão \"Fechar mês\" no topo pra gerar o primeiro PDF.",
    closing_one: "fechamento arquivado",
    closing_many: "fechamentos arquivados",
    closings_confirm_delete: "Apagar esse fechamento? O PDF será removido também.",
    closed_at: "Fechado em",
    vehicles: "Veículos",
    vehicles_sold_label: "Veículos vendidos",
    mark_commissions_paid_label: "Marcar todas as comissões do mês como pagas",
    mark_commissions_paid_hint: "Útil quando você de fato pagou os vendedores no fim do mês — fica registrado no histórico de cada veículo.",
    download: "Baixar",
    change_password_link: "Trocar senha",
    change_password_title: "Trocar minha senha",
    change_password_intro: "Defina uma senha pessoal pra entrar com mais segurança. A senha precisa ter no mínimo 6 caracteres.",
    change_password_current: "Senha atual",
    change_password_new: "Nova senha",
    change_password_confirm: "Confirme a nova senha",
    change_password_show: "Mostrar senhas",
    change_password_mismatch: "A confirmação não bate com a nova senha.",
    change_password_too_short: "A nova senha precisa ter no mínimo 6 caracteres.",
    change_password_success: "Senha trocada com sucesso!",
    monthly_evolution: "Evolução mensal (últimos 12 fechamentos)",
    floor_plans_title: "Floor Plans · Calendário de pagamentos",
    floor_plans_add_plan: "Novo plano",
    floor_plans_edit_plan: "Editar plano",
    floor_plans_add_pay: "Novo pagamento",
    floor_plans_edit_pay: "Editar pagamento",
    floor_plans_empty_plans: "Cadastre seus Floor Plans pra começar (NextGear, Westlake, etc).",
    floor_plans_calendar_hint: "Clique num dia pra ver/adicionar pagamentos.",
    floor_plans_confirm_delete_plan: "Excluir esse Floor Plan? Todos os pagamentos vinculados também serão removidos.",
    floor_plans_confirm_delete_pay: "Excluir esse pagamento?",
    floor_plans_pick_plan_first: "Selecione um Floor Plan.",
    floor_plan: "Floor Plan",
    pending: "A pagar",
    paid: "Pago",
    month_total: "Total do mês",
    today: "Hoje",
    name: "Nome",
    color: "Cor",
    due_date: "Data",
    vehicle_optional: "Veículo (opcional)",
    vehicle_vin_search_placeholder: "Digite o VIN do carro...",
    vin_required: "Digite o VIN primeiro",
    vin_not_found: "VIN não encontrado no estoque",
    or: "OU",
    none: "—",
    notes: "Observação",
    already_paid: "Já está pago",
    payments_for: "Pagamentos do dia",
    mark_paid: "Marcar pago",
    fp_alerts_pending_total: "pagamento(s) Floor Plan precisam de atenção",
    fp_alerts_hint: "Confira na aba Financeiro pra marcar como pago.",
    fp_alerts_overdue: "Atrasados",
    fp_alerts_today: "Vencem hoje",
    fp_alerts_tomorrow: "Vencem amanhã",
    fp_alerts_go: "Ir pro Financeiro",
    more: "mais",
    filter_all_makes: "Todas as marcas",
    filter_all_models: "Todos os modelos",
    // Estoque · sort dropdown + analytics strip + days-in-stock badge
    sort_label: "Ordenar",
    sort_make_az: "Marca A-Z",
    sort_newest: "Mais recente",
    sort_oldest: "Mais tempo parado",
    sort_price_desc: "Preço: maior",
    sort_price_asc: "Preço: menor",
    inv_summary_total: "carros",
    inv_summary_avg_price: "preço médio",
    inv_summary_avg_age: "idade média",
    inv_summary_aging: "parados há +60 dias",
    inv_summary_aging_click: "clique pra filtrar",
    inv_badge_days: "d",
    inv_filter_aging_active: "Somente aging (60+ dias)",
    financial_jump_current: "Mês atual",
    detailed_report_btn: "Relatório detalhado",
    detailed_report_generated: "Relatório gerado — verifique seus downloads",
    filter_all_bodies: "Todos os tipos",
    active_filters: "Filtros ativos",
    clear_filters: "Limpar filtros",
    customers_tab: "Clientes",
    customers_eyebrow: "Banco de compradores",
    customers_title: "Clientes da loja",
    customers_total: "Total de clientes",
    customers_repeat: "Clientes que voltaram",
    customers_total_revenue: "Receita total",
    customers_search_placeholder: "Buscar por nome, telefone ou veículo...",
    customers_no_yet: "Nenhum cliente ainda. Os compradores aparecem aqui depois que você fechar a primeira venda.",
    customers_no_match: "Nenhum cliente encontrado.",
    last_purchase: "Última compra:",
    repeat_customer_badge: "★ Recompra",
    total_spent: "Total gasto",
    vehicles_purchased: "Veículos comprados",
    served_by: "Atendido por:",
    vehicle_one: "veículo",
    import_inv_btn: "Importar página",
    import_inv_eyebrow: "Importar página de inventário",
    import_inv_title: "Importar inventário inteiro",
    import_inv_intro: "Cole o link da página de inventário do site (ex: /inventory). A gente lista todos os carros encontrados e você escolhe quais quer importar de uma vez.",
    import_inv_scan_btn: "Listar carros",
    import_inv_scanning: "Buscando...",
    import_inv_none: "Nenhum carro encontrado nessa página. Confira se a URL está correta.",
    import_inv_select_at_least_one: "Selecione pelo menos um carro.",
    import_inv_selected: "selecionados",
    import_inv_importing: "Importando...",
    import_inv_done: "{n} carro(s) importado(s) com sucesso!",
    import_inv_errors: "{n} carro(s) falharam ao importar.",
    import_inv_skipped: "{n} já estavam no estoque (VIN duplicado) — pulados.",
    import_inv_import_btn: "Importar {n} selecionados",
    import_inv_keep_open: "Voltar",
    select_all: "Selecionar tudo",
    deselect_all: "Limpar seleção",
    errors: "erros",
    close: "Fechar",
    maintenance_tab: "Manutenção",
    post_sales_tab: "Pós-Vendas",
    applications_tab: "Aplicações",
    maintenance_eyebrow: "Pátio · Peças · Oficina",
    maintenance_title: "Manutenção dos veículos",
    maintenance_total_cars: "Veículos",
    maintenance_total_services: "Serviços feitos",
    maintenance_total_cost: "Custo total de manutenção",
    maintenance_total_cost_short: "Custo total",
    maintenance_search_placeholder: "Buscar por marca, modelo, ano ou VIN...",
    maintenance_no_vehicles: "Nenhum veículo cadastrado ainda.",
    maintenance_no_match: "Nenhum veículo encontrado.",
    maintenance_services: "Serviços registrados",
    maintenance_services_count: "Serviços",
    maintenance_no_services_yet: "Nenhum serviço registrado pra esse veículo ainda.",
    maintenance_add_service: "Novo serviço",
    maintenance_edit_service: "Editar serviço",
    maintenance_description_placeholder: "Ex: Troca de óleo + filtro, alinhamento, reparo do farol...",
    maintenance_parts_optional: "Peças usadas (uma por linha · opcional)",
    maintenance_parts_placeholder: "Óleo 5W30\nFiltro de óleo\nPastilha de freio",
    maintenance_attachments: "Nota fiscal / fotos",
    maintenance_attach_hint: "Clique pra anexar nota fiscal ou foto do serviço",
    maintenance_confirm_delete: "Apagar esse serviço? O custo sai automaticamente do veículo.",
    by: "por",
    parts: "Peças",
    file: "Arquivo",
    description: "Descrição",
    amount: "Valor",
    date: "Data",
    loading: "Carregando...",
  },
  en: {
    app_name: "Intercar Manager",
    tagline: "Complete management for your dealership",
    welcome_back: "Welcome back",
    create_account_title: "Create your account and dealership",
    auth_hero_line1: "Drive",
    auth_hero_line2: "your dealership",
    auth_hero_line3: "forward.",
    auth_hero_blurb: "Inventory, sales, leads, financials and team — all in one place, in real time.",
    auth_live_status: "System online",
    auth_eyebrow_login: "Restricted access",
    auth_eyebrow_signup: "New account",
    management_suite: "Management Suite",
    show: "Show",
    hide: "Hide",
    or: "or",
    dp_section: "Down Payment",
    dp_fully_paid: "Fully Paid",
    dp_remaining: "Remaining",
    dp_owes: "Owes",
    dp_entrance: "Down Payment",
    dp_agreed: "Agreed Down Payment",
    dp_paid_so_far: "Paid So Far",
    dp_balance: "Balance",
    dp_history: "Payment History",
    dp_no_payments: "No payments recorded yet.",
    dp_add_payment: "Add Payment",
    dp_view_history: "View History",
    dp_amount: "Amount",
    dp_amount_required: "Enter an amount greater than zero",
    dp_payment_saved: "Payment saved and receipt generated!",
    dp_save_and_print: "Save & Print Receipt",
    dp_notes_placeholder: "e.g. cash on hand, customer promised the rest on Friday…",
    dp_all_paid_msg: "Customer has fully paid the down payment. Great job!",
    missing_purchase_singular: "1 car without a purchase price",
    missing_purchase_plural: "cars without a purchase price",
    missing_purchase_hint: "— fill it in so the monthly closing is correct. Highlighted rows are missing this value.",
    missing_purchase_row_hint: "Click to fill in",
    select_option: "Select...",
    select_bank: "Select a bank...",
    reg_calc_title: "MA Calculator",
    reg_calc_apply: "Apply",
    reg_calc_applied: "Applied",
    reg_calc_sale: "Sale price",
    reg_calc_trade_in: "Trade-in",
    reg_calc_taxable: "Taxable base",
    reg_calc_tax: "Sales tax (6.25%)",
    reg_calc_reg_fee: "Registration fee",
    reg_calc_title_fee: "Title fee",
    reg_calc_runner_fee: "Runner fee",
    reg_calc_total: "Suggested total",
    funded: "Funded",
    not_funded: "No",
    funded_marked: "FUNDED — bank paid the dealership",
    funded_undone: "FUNDED removed",
    mark_funded: "Mark FUNDED — bank paid the dealership",
    unmark_funded: "Unmark FUNDED",
    commission_blocked_until_funded: "Mark FUNDED first — commission can only be paid after the bank funds",
    theme_auto: "Auto (follow store preference)",
    theme_auto_short: "Auto",
    theme_day: "Day mode (light)",
    theme_day_short: "Day",
    theme_night: "Night mode (dark)",
    theme_night_short: "Night",
    reg_in_price_label: "Include in car price",
    reg_in_price_on_hint: "Dealership absorbed registration → it counts as a vehicle expense.",
    reg_in_price_off_hint: "Customer pays separately → not counted as expense (passthrough).",
    discount_label: "Discount",
    discount_hint: "(optional — subtracted from final price)",
    discount_applied_hint: "Discount applied · subtracted from Final Sold Price",
    full_name: "Full name",
    dealership_name: "Dealership name",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    create_account: "Create account",
    no_account: "No account? Create one",
    have_account: "Already have an account? Sign in",
    dashboard: "Dashboard",
    inventory: "Inventory",
    sales: "Sales",
    financials: "Financials",
    settings: "Settings",
    sign_out: "Sign out",
    overview: "Overview",
    total_vehicles: "Total vehicles",
    in_stock: "In stock",
    reserved: "Reserved",
    sold: "Sold",
    on_display: "On display",
    open_deals_title: "Open deals",
    open_deals_subtitle: "Sold · awaiting delivery",
    open_deals_empty: "No open deals.",
    pipeline_top_sellers_eyebrow: "Top sellers",
    pipeline_month_revenue: "Month revenue",
    pipeline_deals_closed_eyebrow: "Closed",
    pipeline_deals_closed: "closed",
    pipeline_deal: "deal",
    pipeline_deals: "deals",
    pipeline_leaderboard_empty: "No sales closed this month yet.",
    pipeline_velocity_eyebrow: "Sales pulse",
    pipeline_velocity_title: "Last 14 days",
    pipeline_this_week: "This week",
    pipeline_vs_prev_week: "vs prev week",
    pipeline_today: "Today",
    pipeline_week_revenue: "7d revenue",
    pipeline_open_deals_short: "Open",
    pipeline_prev_week: "Prev week",
    pipeline_kpi_open_deals: "Open deals",
    pipeline_kpi_revenue: "Projected revenue",
    pipeline_kpi_entrada_paid: "Down payments received",
    pipeline_kpi_entrada_due: "Down payments due",
    deal_days_open_hint: "Days since sale",
    deal_stale_hint: "Deal stuck for a while — chase the salesperson or call the bank",
    pipeline_kpi_stale: "Stuck >20d",
    stale_kpi_hint: "Click to filter",
    stale_filter_active: "Filter active",
    stale_filter_label: "Filter:",
    stale_filter_all: "All",
    stale_filter_20: "Stuck >20d",
    stale_filter_30: "Critical >30d",
    stale_view_20: "Deals stuck for more than 20 days",
    stale_view_30: "Critical deals · more than 30 days stuck",
    stale_empty_good_news: "Good news! No deals stuck in that range.",
    clear_filters: "Clear",
    commission_paid: "Paid",
    commission_pending: "Pending",
    available: "Available",
    delivery_view_active: "Active",
    delivery_view_delivered: "Delivered",
    delivered_this_month: "Delivered this month",
    avg_delivery_days: "Avg. delivery time (days)",
    pending_deliveries: "Pending",
    post_sales_from_delivered: "Ticket from delivered car",
    post_sales_pick_delivered_title: "Select the delivered car",
    post_sales_pick_delivered_subtitle: "Click a car and the ticket is created with prefilled data.",
    post_sales_no_delivered: "No delivered cars yet.",
    invested: "Invested in stock",
    revenue: "Total revenue",
    profit: "Total profit",
    avg_ticket: "Average ticket",
    monthly_performance: "Monthly performance",
    months_short: "months",
    leads_title: "Leads",
    leads_count_label: "leads",
    unassigned_label: "Unassigned",
    my_leads: "My leads",
    assigned: "Assigned",
    add_lead: "Add lead",
    edit_lead: "Edit lead",
    no_leads: "No leads in this view.",
    search_lead: "Search name, phone, email...",
    contact: "Contact",
    last_contact: "Last contact",
    interest_make_model: "Interest (make/model)",
    budget: "Budget",
    payment_type: "Payment type",
    payment_cash: "Cash",
    payment_financing: "Financing",
    claim_lead: "Claim lead",
    lead_claimed: "Lead claimed!",
    import_monday: "Import from Monday",
    confirm_monday_import: "Import/update Monday leads now?",
    imported: "Imported",
    updated: "Updated",
    total: "Total",
    bdc_users_title: "BDC users",
    bdc_users_hint: "BDC users only see the dashboard and the Leads tab. They create, edit and assign leads to salespeople.",
    add_bdc: "Add BDC",
    no_bdc_users: "No BDC users yet.",
    team_title: "Team",
    team_hint: "Add salespeople and BDCs and pick exactly what each person can see.",
    add_team_member: "Add member",
    edit_team_member: "Edit member",
    no_team_members: "No team members yet.",
    role: "Role",
    permissions_label: "Permissions",
    permissions_hint: "Pick which areas this person can access. You can change this anytime.",
    link_salesperson: "Link to existing salesperson",
    select_salesperson: "Pick a salesperson",
    no_available_salesperson: "All salespeople already have a login. Create a new salesperson first.",
    must_pick_salesperson: "Pick which salesperson this login belongs to.",
    leave_blank_to_keep: "leave blank to keep",
    change_photo: "Change photo",
    team_photo_hint: "Click the photo to upload an image from your computer (optional).",
    owner_role: "Owner",
    owner_role_hint: "Owners get full access — no permission boxes needed.",
    owner_full_access_note: "Full access — sees everything in the system.",
    self_badge: "(you)",
    manager: "Manager",
    general_role: "General",
    fi_role: "F&I",
    lead_status_new: "New",
    lead_status_in_progress: "In progress",
    lead_status_hot_lead: "Hot lead",
    lead_status_follow_up: "Follow-up",
    lead_status_cold: "Cold",
    lead_status_no_answer: "No answer",
    lead_status_wrong_number: "Wrong number",
    lead_status_deal_closed: "Deal closed",
    lead_status_lost: "Lost",
    lead_status_future: "Future",
    lead_source_facebook: "Facebook",
    lead_source_instagram: "Instagram",
    lead_source_google_ads: "Google Ads",
    lead_source_cargurus: "CarGurus",
    lead_source_carfax: "Carfax",
    lead_source_craigslist: "Craigslist",
    lead_source_walk_in: "Walk-in",
    lead_source_referral: "Referral",
    lead_source_phone: "Phone",
    lead_source_bdc: "BDC",
    lead_source_whatsapp: "WhatsApp",
    lead_source_marketplace: "Marketplace",
    lead_source_tiktok: "TikTok",
    lead_source_youtube: "YouTube",
    lead_source_repeat_customer: "Repeat customer",
    lead_source_website: "Own website",
    lead_source_unknown: "Not informed",
    lead_source_other: "Other",
    lead_source_label: "How did the customer find us?",
    lead_source_hint: "Helps us know which marketing channel drives the most sales.",
    lead_source_panel_title: "Sales by source",
    lead_source_panel_hint: "Where the customers who closed a deal this month came from.",
    lead_source_panel_empty: "No sales with a source recorded this month.",
    lead_source_top_channel: "Top channel",
    leaderboard_title: "Salesperson leaderboard · this month",
    leaderboard_empty: "No sales yet this month.",
    leaderboard_others: "Other salespeople",
    vendedor_do_mes: "TOP SELLER OF THE MONTH",
    weekly_promo_title: "Weekly promotion",
    no_promotion: "No active promotion.",
    create_promotion: "Create promotion",
    promo_image: "Image",
    upload_image: "Upload image",
    promo_title_placeholder: "e.g. Friday discount day",
    promo_desc_placeholder: "Details, prices, conditions...",
    valid_until: "Valid until",
    optional: "optional",
    title: "Title",
    description: "Description",
    add_vehicle: "Add vehicle",
    import_from_url: "Import from URL",
    paste_url: "Paste the car URL from your site",
    import: "Import",
    importing: "Importing...",
    import_success: "Data imported! Review and save.",
    import_failed: "Could not import from this URL.",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    search: "Search...",
    make: "Make",
    model: "Model",
    year: "Year",
    color: "Color",
    vin: "VIN Number",
    purchase_price: "Purchase price",
    sale_price: "Sale price",
    expenses: "Expenses",
    expenses_total: "Total expenses",
    expense_items: "Expense breakdown",
    add_expense: "Add expense",
    expense_description: "Expense description",
    expense_amount: "Amount",
    expense_category: "Category",
    expense_date: "Date",
    expense_attachments: "Invoices / proofs",
    expense_no_items: "No expenses yet. Add the first one!",
    cat_parts: "Parts",
    cat_labor: "Labor",
    cat_paint: "Paint/body",
    cat_documentation: "Documentation",
    cat_transport: "Transport/towing",
    cat_detail: "Cleaning/detailing",
    cat_inspection: "Inspection",
    cat_other: "Other",
    real_profit: "Estimated real profit",
    upload_invoice: "Attach invoice/photo",
    salespeople: "Salespeople",
    salesperson: "Salesperson",
    select_salesperson: "Select salesperson",
    add_salesperson: "Add salesperson",
    salesperson_name: "Name",
    commission_amount: "Commission ($)",
    commission_paid: "Paid",
    commission_pending: "Pending",
    mark_paid: "Mark as paid",
    mark_unpaid: "Mark as pending",
    paid: "Paid",
    pending: "Pending",
    phone: "Phone",
    active: "Active",
    inactive: "Inactive",
    no_salespeople: "No salespeople yet.",
    financial: "Financial",
    financial_dashboard: "Financial dashboard",
    monthly_closing: "Monthly closing",
    gross_profit: "Cars profit",
    operational_expenses: "Operational expenses",
    operational_total: "Total expenses",
    paid_commissions: "Paid commissions",
    net_profit: "Net profit",
    cars_sold_in_month: "Cars sold this month",
    all_sold_cars: "All sold cars",
    buyer_dob: "Customer birthday",
    notif_birthdays: "Customer birthdays",
    notif_assigned_leads: "Leads assigned to you",
    notif_stale_leads: "Leads unanswered by salesperson (24h+)",
    no_response_label: "no response",
    daily_summary_btn: "Daily recap",
    inventory_search_placeholder: "Search car, VIN, plate, year or customer...",
    rec_search_placeholder: "Search by customer, phone, car or VIN...",
    sold_search_placeholder: "Search by customer name, VIN or car...",
    results_label: "result(s)",
    sold_search_empty: "No sales found for this search",
    view_expenses: "View expenses",
    revert_to_stock: "Return to stock",
    revert_sale_hint: "Client backed out? Return the car to inventory and clear sale data (buyer, sold price, salesperson, commission, delivery).",
    confirm_revert_sale: "Are you sure? The car will return to inventory and sale data (buyer, salesperson, commission, delivery step) will be cleared. Expenses and purchase price will be kept.",
    returned_to_stock: "Car returned to inventory!",
    lost_sale_title: "Why did the sale fall through?",
    lost_sale_hint: "Pick a reason. It will show up in your Financial report so you can track lost sales.",
    lost_reason: "Reason",
    notes: "Notes",
    lost_notes_placeholder: "Extra detail (optional)",
    confirm: "Confirm",
    lost_sales_title: "Lost sales",
    lost_revenue: "Lost revenue",
    reason_financing_denied: "Financing denied",
    reason_client_changed_mind: "Client changed mind",
    reason_mechanical_issue: "Mechanical issue",
    reason_price_disagreement: "Price disagreement",
    reason_found_better_deal: "Found better deal",
    reason_other: "Other",
    add_expense: "Add expense",
    expense_date: "Date",
    expense_category: "Category",
    expense_description: "Description",
    expense_amount: "Amount",
    expense_attachment: "Receipt",
    no_expenses: "No expenses recorded for this month.",
    cat_rent: "Rent",
    cat_water: "Water",
    cat_electricity: "Electricity",
    cat_internet: "Internet",
    cat_phone: "Phone",
    cat_salary: "Salaries",
    cat_marketing: "Marketing",
    cat_maintenance: "Maintenance",
    cat_taxes: "Taxes",
    cat_floor_plan: "Floor Plan",
    cat_post_sale: "Post-Sale",
    cat_fi_commission: "F&I Commission",
    cat_other: "Other",
    operational_credits: "Operational credits",
    add_credit: "Add credit",
    edit_credit: "Edit credit",
    no_credits: "No credits this month.",
    net_operational: "Net operational",
    credit_cat_sublease: "Sublease",
    credit_cat_refund: "Refund",
    credit_cat_commission: "Commission received",
    credit_cat_other: "Other credits",
    credit_cat_receivable_payment: "Receivable",
    credit_auto: "Auto",
    credit_auto_tooltip: "Auto-generated credit from a paid Receivable installment",
    credit_managed_in_receivables: "In Receivables",
    // Receivables
    receivables_tab: "Receivables",
    receivables_title: "Receivables",
    receivables_eyebrow: "Payments & installment plans",
    rec_add: "New receivable",
    rec_edit: "Edit receivable",
    rec_vehicle: "Vehicle",
    rec_pick_vehicle: "Pick a vehicle",
    rec_no_vehicle: "No vehicle (walk-in customer)",
    rec_no_vehicle_short: "Walk-in customer",
    rec_print_schedule: "Print payment schedule for customer",
    rec_freq_change_warning: "Pending installments will be re-scheduled with the new frequency. Already-paid ones stay untouched.",
    rec_installment_amount_hint: "Applied to pending installments only. Paid ones stay untouched.",
    // ---------- Defer to next month ----------
    defer_col_hint: "Defer to next month",
    move_store_btn: "Change car's store (salesperson stays the same)",
    move_store_title: "Move closing to",
    move_store_keep_seller: "The salesperson stays the same — only the store where the car counts in the closing changes (receipts and receivables move along).",
    move_store_done: "Car moved — salesperson kept",
    fund_override_confirm: "You are the OWNER — release FUNDED anyway? (e.g. down payment financed in-house — this will be logged)",
    defer_to_next_month_tooltip: "Defer this car to next month's closing",
    defer_undo_tooltip: "Bring this car back to the current month",
    defer_confirm: "Defer this car to next month's closing? It will be removed from current month's profit, commissions and F&I commission.",
    defer_undo_confirm: "Bring this car back to the current month?",
    defer_done: "Car deferred to next month",
    defer_undone: "Car restored to current month",
    deferred_to_label: "Deferred to",
    delivered_in_month_label: "Delivered in",
    delivered_auto_migrate_hint: "Auto-migrated to the delivery month",
    delivered_label: "Delivered",
    delivered_on: "Delivered on",
    // ---------- F&I Officer ----------
    fi_title: "F&I Officer (Finance & Insurance)",
    fi_subtitle: "Register the person who closes financing deals. The system automatically books a commission expense every time a car is marked FUNDED.",
    fi_photo: "Photo",
    fi_photo_uploaded: "Photo updated",
    fi_name: "Full name",
    fi_name_placeholder: "e.g. John Smith",
    fi_weekly_salary: "Weekly salary (US$)",
    fi_commission_per_funded: "Commission per funded car (US$)",
    fi_pay_weekly: "Pay this week's salary",
    fi_week_already_paid: "Current week already paid",
    fi_remove: "Remove F&I",
    fi_remove_confirm: "Remove F&I officer? Already booked expenses stay in history.",
    fi_legal_note: "Commission is logged as an operational expense automatically when a car is marked FUNDED. Unfunding the car removes the expense.",
    fi_month_commissions: "Commissions this month",
    fi_this_week_salary: "This week's salary",
    fi_last_paid: "Last salary paid",
    fi_paid: "PAID",
    fi_pending: "PENDING",
    fi_already_paid_week: "Salary for this week was already paid",
    fi_salary_paid: "Salary booked in Financial",
    removed: "Removed",
    payment_auth_btn: "Payment Authorization",
    payment_auth_pick_lang: "Document language",
    rec_customer_name: "Customer name",
    rec_customer_required: "Customer name is required",
    rec_phone: "Phone",
    rec_total_amount: "Total amount",
    rec_down_payment: "Down payment (optional)",
    rec_down_payment_short: "Down payment",
    rec_down_payment_hint: "Paid today. Reduces the financed amount.",
    rec_down_payment_receipt: "Down payment receipt",
    purchase_agreement: "Sale Contract",
    forgot_password: "Forgot my password",
    forgot_title: "Recover password",
    forgot_hint: "Type your email and we'll send you a link to reset your password.",
    forgot_send: "Send link",
    forgot_sent: "If the email exists, you'll receive the reset link shortly. Also check your spam folder.",
    back_to_login: "Back to login",
    reset_title: "New password",
    reset_hint: "Choose a new password for your account.",
    new_password_label: "New password",
    confirm_password_label: "Confirm password",
    reset_submit: "Reset password",
    reset_success: "Password reset! Sign in with your new password.",
    reset_invalid: "Invalid or expired link. Request a new one.",
    passwords_dont_match: "Passwords don't match",
    password_min: "Password needs at least 6 characters",
    notif_title: "Notifications",
    diag_title: "Account diagnosis",
    test_email_btn: "Send test email",
    net_check_label: "Net check (financing)",
    send_closing_email: "Email the closing",
    negotiation_sheet_ready: "Negotiation sheet finalized",
    open_sheet: "Open sheet",
    resend_sale_email: "Resend sale email",
    diag_healthy: "All good! No issues found on this account.",
    diag_repair: "Auto-repair",
    diag_repaired: "Account repaired!",
    diag_fix_note: "Red items without auto-repair: recreate the credentials under Team or ask the person to retry.",
    diag_check_login: "Login and password set",
    diag_check_store: "User's store",
    diag_check_group: "Store-group link",
    diag_check_permissions: "Access permissions",
    diag_check_sp_link: "Salesperson record link",
    diag_check_sp_store: "Login store = salesperson store",
    diag_check_duplicates: "Duplicate accounts",
    nav_delivery: "Deliveries",
    notif_empty: "All clear! No pending alerts.",
    notif_rmv: "RMV pending",
    notif_stuck: "Deliveries stuck +45d",
    notif_overdue: "Overdue payments",
    notif_due_today: "Payments due today",
    notif_revision_ready: "Ready at revision",
    notif_new_leads: "New leads",
    activity_tab: "Activity",
    activity_title: "Activity Log",
    activity_hint: "Who did what and when — important actions across your stores.",
    activity_empty: "No activity recorded yet.",
    activity_load_more: "Load more",
    activity_search: "Search by user, action or item...",
    act_vehicle_deleted: "deleted the car",
    act_vehicle_transferred: "transferred the car",
    act_vehicle_funded: "marked FUNDED:",
    act_vehicle_unfunded: "unmarked FUNDED:",
    act_sale_corrected: "corrected sale values:",
    act_expense_created: "added the expense",
    act_expense_deleted: "deleted the expense",
    act_receivable_deleted: "deleted the receivable of",
    act_team_member_deleted: "removed from the team:",
    act_salesperson_transferred: "transferred the salesperson",
    bank_other_option: "Other bank (type it)...",
    bank_other_placeholder: "Type the new bank's name...",
    finance_term: "Nº of installments",
    finance_installment: "Installment amount (US$)",
    warranty_months_label: "Warranty (months)",
    payment_frequency_label: "Payment frequency",
    freq_monthly: "Monthly",
    freq_weekly: "Weekly",
    doc_fee_included: "DOC FEE US$ 499.00 — included on every financing (printed on the contract)",
    doc_fee_charge: "Charge Doc Fee (US$ 499.00)",
    doc_fee_hint: "Choose whether the doc fee is charged on this cash deal — goes straight on the contract.",
    doc_fee_yes: "Charge US$ 499",
    doc_fee_no: "Don't charge (discount)",
    doc_fee_mandatory: "Mandatory on every financing — printed automatically on the contract.",
    contract_edit_title: "Sale Contract — review before printing",
    contract_edit_hint: "Changes made here apply ONLY to this PDF — they don't change the closing or the car's data.",
    contract_generate: "Generate contract PDF",
    rate_label: "Rate (%)",
    referral_label: "Referral / Source",
    trade_in_title: "Trade-in vehicle",
    trade_in_value: "Appraisal",
    payoff: "Payoff",
    payoff_bank: "Payoff bank",
    vex_fix_values: "Fix values (owner only)",
    vex_fix_save: "Save correction",
    vex_fix_saved: "Values corrected",
    vex_fix_hint: "Owner correction: directly adjusts the closing. Logged in the car's history.",
    rec_down_payment_paid_on: "Down payment received on",
    rec_total: "Total",
    rec_paid: "Paid",
    rec_remaining: "Remaining",
    rec_frequency: "Frequency",
    rec_freq_weekly: "Weekly",
    rec_freq_biweekly: "Biweekly",
    rec_freq_monthly: "Monthly",
    rec_installment_count: "# of installments",
    rec_installment_amount: "Installment amount",
    rec_installments: "installments",
    rec_start_date: "First due date",
    rec_due_date: "Due date",
    rec_amount: "Amount",
    rec_status: "Status",
    rec_status_active: "Active",
    rec_status_completed: "Paid off",
    rec_status_cancelled: "Cancelled",
    rec_filter_all: "All",
    rec_paid_at: "Paid on",
    rec_paid_label: "Paid",
    rec_pending: "Pending",
    rec_mark_paid: "Mark paid",
    rec_marked_paid: "Installment paid!",
    rec_undo_paid: "Undo",
    rec_confirm_unpay: "Are you sure you want to revert this payment?",
    rec_total_remaining: "Total to receive",
    rec_overdue: "Overdue",
    rec_due_today: "Due today",
    rec_due_week: "Next 7 days",
    rec_paid_this_month: "Received this month",
    rec_reminders: "Collection reminders",
    rec_empty: "No receivables yet.",
    rec_notes: "Notes",
    rec_preview_schedule: "Schedule preview",
    rec_more: "more",
    rec_overview_card: "To receive",
    rec_overview_overdue: "overdue",
    rec_edit_due_date: "Edit date",
    rec_edit_propagate: "Shift later ones",
    delivered_archive_eyebrow: "Delivery archive",
    delivered_archive_title: "Sold & Delivered",
    delivered_archive_count: "cars delivered",
    delivered_archive_current: "Current month",
    delivered_trend_title: "Deliveries · Last 6 months",
    delivered_trend_vs_prev: "vs. previous month",
    delivered_archive_export_pdf: "Export month PDF",
    expand: "Expand",
    collapse: "Collapse",
    // Sale finalization
    mark_as_sold: "Mark as sold",
    sale_finalize: "Finalize sale",
    sale_breakdown: "Payment breakdown",
    down_payment: "Down payment",
    bank_check_amount: "Bank check",
    registration_cost: "Registration / Title",
    registration_cost_hint: "How much you'll spend to register / title this car",
    final_sold_price: "Final sale price",
    asking_price: "Asking price",
    difference: "Difference",
    over_asking: "over asking",
    under_asking: "under asking",
    cat_registration: "Registration",
    rec_reminder_title: "Collection reminder",
    rec_alert_dismiss: "OK, later",
    rec_alert_open: "Open receivables",
    push_enabled: "Notifications enabled!",
    push_disabled: "Notifications disabled.",
    push_enable_hint: "Get a phone alert when a car is sold",
    push_disable_hint: "Disable phone notifications",
    push_permission_denied: "Permission denied. Enable it in your browser settings.",
    push_not_supported: "Your browser doesn't support push notifications.",
    select_month: "Select month",
    set_login: "Set login",
    edit_login: "Edit login",
    revoke_login: "Remove login",
    has_login: "Has login",
    no_login: "No login",
    login_email: "Login email",
    new_password: "New password",
    salesperson_login_hint: "The salesperson can log in with this email and password. They will NOT see what you paid for the car or profits.",
    confirm_revoke_login: "Remove this salesperson's login? They won't be able to access the app anymore.",
    sales_report: "Sales report",
    period: "Period",
    all_time: "All time",
    this_month: "This month",
    last_month: "Last month",
    by_salesperson: "By salesperson",
    detailed_sales: "Detailed sales",
    sales_count: "Sales",
    total_revenue: "Total revenue",
    total_commission: "Total commission",
    day_of_month: "Day",
    sale_date: "Sale date",
    unassigned: "Unassigned",
    change_salesperson: "Change salesperson",
    description: "Description",
    images: "Vehicle photos",
    status: "Status",
    transmission: "Transmission",
    fuel_type: "Fuel type",
    body_type: "Body type",
    buyer_name: "Buyer name",
    buyer_phone: "Buyer phone",
    buyer_email: "Buyer email",
    buyer_address: "Buyer address",
    payment_method: "Payment method",
    sold_price: "Final sold price",
    no_vehicles: "No vehicles yet.",
    confirm_delete: "Confirm deletion?",
    public_api: "Public API",
    api_description: "Use this endpoint on your external site to pull inventory automatically.",
    api_token: "API token",
    regenerate: "Generate new token",
    copy: "Copy",
    copied: "Copied!",
    profit_per_vehicle: "Profit per vehicle",
    cost: "Cost",
    sold_at: "Sold at",
    move_to: "Move to",
    saved: "Saved!",
    error_generic: "Something went wrong.",
    invalid_credentials: "Invalid email or password",
    email_in_use: "Email already in use",
    pipeline: "Sales pipeline",
    finalize_sale: "Finalize sale",
    delivery: "Delivery pipeline",
    delivery_pipeline_title: "Vehicle Delivery",
    edit_step: "Edit step",
    advance_step: "Advance step",
    back_step: "Go back step",
    notes: "Notes",
    bank: "Bank",
    delivery_notes: "Delivery notes",
    no_deliveries: "No vehicles in delivery right now.",
    delivered_section_title: "Already delivered",
    delivered_section_one: "delivered car",
    delivered_section_many: "delivered cars",
    delivered_label: "Delivered",
    reopen_delivery: "Reopen delivery",
    reopen_delivery_confirm: "Reopen this delivery? The car will move back to step 7 (Registration) and the delivered date will be cleared.",
    delivery_reopened: "Delivery reopened — car moved back to step 7",
    no_stuck_deliveries: "No stuck cars right now.",
    stuck_alert_title_one: "car stuck for more than 45 days",
    stuck_alert_title_many: "cars stuck for more than 45 days",
    stuck_alert_hint: "Check them out — a step is blocked and the delivery is on hold.",
    stuck_days_chip: "Stuck for {d} days",
    show_only_stuck: "Show stuck only",
    show_all: "Show all",
    step_1: "Sold",
    step_2: "Deal sheet + Receipt",
    bank_contract_short: "Contract",
    bank_contract_signed_on: "Bank contract signed",
    bank_contract_pending: "Mark bank contract as signed",
    bank_contract_marked: "Contract marked as signed!",
    bank_contract_unmarked: "Contract mark removed.",
    receipts: "Receipts",
    new_receipt: "New receipt",
    no_receipts_yet: "No receipts issued yet.",
    receipt_amount: "Deposit amount",
    receipt_amount_required: "Enter the deposit amount",
    receipt_created: "Receipt created!",
    non_refundable_amount: "Non-refundable amount",
    create_and_print: "Create & print",
    address: "Address",
    open_pdf: "Open PDF",
    step_3: "Documents",
    doc_drive: "Driver's License",
    doc_insurance: "Insurance",
    doc_income: "Proof of Income",
    doc_address: "Proof of Address",
    doc_other: "Other documents",
    doc_uploaded: "document(s)",
    doc_no_files_yet: "No file here yet — click to add.",
    doc_add_file: "Add file",
    // Parts notes block on the Overview dashboard
    parts_notes_title: "Parts to Buy",
    parts_notes_eyebrow: "Notes Board",
    parts_notes_subtitle: "Track parts you need to buy and shop reminders",
    parts_notes_scratch_label: "Notes",
    parts_notes_scratch_placeholder: "Write anything — part numbers, suppliers, reminders…",
    parts_notes_list_label: "Parts list",
    parts_notes_list_placeholder: "e.g. Front brake pads · Civic 2018",
    parts_notes_add: "Add part",
    parts_notes_empty: "No items yet. Add your first part above.",
    parts_notes_pending: "pending",
    parts_notes_done: "done",
    parts_notes_save: "Save notes",
    parts_notes_saved: "Notes saved",
    parts_notes_last_update: "Updated by",
    parts_notes_manager_only: "Only managers can edit",
    // Revision status badge on delivery cards
    revision_badge_in_shop: "REVISION: AT SHOP",
    revision_badge_ready: "REVISION: READY",
    revision_badge_pending: "REVISION: PENDING",
    // WhatsApp quick-contact messages (wa.me deep-link)
    wa_button_label: "WhatsApp",
    wa_delivery_message: "Hi {name}! Quick update on your {vehicle}. It's now at step: {step}. Let me know if you have any questions.",
    wa_revision_ready_message: "Hi {name}! Good news — your {vehicle} just came out of service and is ready for pickup. Want to schedule a time?",
    wa_delivered_message: "Hi {name}! Thanks for trusting us with your {vehicle}. Reach out anytime if you need anything.",
    vex_add_post_sale: "Add post-sale expense",
    post_sale_desc_placeholder: "e.g. Brake pad replacement",
    step_4: "Maintenance",
    step_5: "Insurance",
    step_6: "Title received",
    step_7: "Registration",
    step_8: "Delivered",
    save_step: "Save step",
    bank_name_label: "Bank name",
    delivered: "Delivered",
    in_progress: "In progress",
    no_photo: "No photo",
    files: "Files",
    upload_file: "Upload file",
    upload_for_step: "Attach files · Step",
    drag_drop: "Drag files here or click to select",
    no_files_yet: "No files on this step yet.",
    file_too_large: "File too large (max 20MB)",
    download: "Download",
    view: "View",
    step_notes_label: "Notes for this step",
    step_notes_placeholder: "e.g. Customer asked for brake pad replacement and tire rotation...",
    save_notes: "Save notes",
    delivery_photos: "Delivery photos",
    delivery_photos_hint: "Upload all photos of the car at the moment of delivery (exterior, interior, odometer, paperwork, etc.). No quantity limit.",
    photos_count: "photos",
    photos_imported: "photos imported — all will be saved",
    vehicle_history: "History",
    close_month_btn: "Close month",
    close_month_title: "Close and export",
    close_month_intro: "The closing only counts cars FUNDED by the bank during the month. Sold-but-unfunded deals stay open and roll into next month.",
    closing_funded_vehicles: "Funded vehicles",
    credits_total: "Operational credits",
    closing_receivables_received: "Receivables received",
    purchase_missing_badge: "No price",
    purchase_missing_hint: "Purchase price not filled — real profit is overstated. Click the value to edit.",
    purchase_missing_count: "without purchase price",
    notifications_title: "Email notifications",
    notifications_description: "Get a short heads-up in your inbox every time something material happens. Sent to you (owner) and every manager.",
    notifications_team_events_title: "Team notifications",
    notifications_team_events_hint: "When ON, fires email alerts to you and managers for each event below:",
    notifications_status_on: "Notifications enabled",
    notifications_status_off: "Notifications disabled",
    notif_event_sold: "Car sold",
    notif_event_funded: "Car funded by the bank",
    notif_event_delivered: "Car delivered to customer",
    notif_event_application: "New credit application",
    notif_event_down_payment: "Down payment recorded",
    notif_event_installment: "Receivable installment paid",
    notif_event_lead: "New lead created",
    fp_inventory_eyebrow: "Quick lookup",
    fp_inventory_title: "Inventory by Floor Plan",
    fp_inventory_units: "financed cars",
    fp_inventory_title_pending: "titles pending",
    fp_inventory_title_pending_short: "title",
    fp_inventory_title_pending_section: "Title pending · sold but not funded",
    fp_inventory_on_lot_section: "On the lot",
    fp_inventory_search_placeholder: "Search by car, VIN, buyer, stock #...",
    fp_inventory_no_plans: "Add a floor plan first to start organising inventory.",
    fp_inventory_no_matches: "No cars match this search.",
    fp_inventory_empty_plan: "No cars assigned to this floor plan yet.",
    fp_inventory_orphans_title: "No floor plan",
    fp_inventory_orphans_hint: "cars with no payment linked",
    fp_on_lot_short: "on lot",
    fp_pending_short: "title pend.",
    floor_plan_label: "Floor Plan",
    floor_plan_hint: "where the car came from (for the title chase)",
    floor_plan_none: "No floor plan",
    floor_plan_no_plans_hint: "Add a floor plan in Financial → Floor Plans.",
    closing_open_deals_title: "Open deals",
    closing_open_deals_hint: "These cars were sold but the bank hasn't funded yet — they'll be picked up in next month's closing automatically.",
    close_month_success: "Month closed and PDF downloaded!",
    close_and_export: "Close and download PDF",
    closings_archive_title: "Closings folder",
    closings_archive_empty: "No closed months yet. Use the \"Close month\" button at the top to generate the first PDF.",
    closing_one: "archived closing",
    closing_many: "archived closings",
    closings_confirm_delete: "Delete this closing? The PDF will be removed too.",
    closed_at: "Closed at",
    vehicles: "Vehicles",
    vehicles_sold_label: "Vehicles sold",
    mark_commissions_paid_label: "Mark all the month's commissions as paid",
    mark_commissions_paid_hint: "Useful when you actually paid the salespeople at month-end — gets logged into each vehicle's history.",
    download: "Download",
    change_password_link: "Change password",
    change_password_title: "Change my password",
    change_password_intro: "Set a personal password for safer access. Minimum 6 characters.",
    change_password_current: "Current password",
    change_password_new: "New password",
    change_password_confirm: "Confirm new password",
    change_password_show: "Show passwords",
    change_password_mismatch: "Confirmation doesn't match the new password.",
    change_password_too_short: "New password must be at least 6 characters.",
    change_password_success: "Password changed successfully!",
    monthly_evolution: "Monthly evolution (last 12 closings)",
    floor_plans_title: "Floor Plans · Payment calendar",
    floor_plans_add_plan: "New plan",
    floor_plans_edit_plan: "Edit plan",
    floor_plans_add_pay: "New payment",
    floor_plans_edit_pay: "Edit payment",
    floor_plans_empty_plans: "Add your Floor Plans to start (NextGear, Westlake, etc).",
    floor_plans_calendar_hint: "Click a day to view/add payments.",
    floor_plans_confirm_delete_plan: "Delete this Floor Plan? All linked payments will be removed too.",
    floor_plans_confirm_delete_pay: "Delete this payment?",
    floor_plans_pick_plan_first: "Pick a Floor Plan.",
    floor_plan: "Floor Plan",
    pending: "Pending",
    paid: "Paid",
    month_total: "Month total",
    today: "Today",
    name: "Name",
    color: "Color",
    due_date: "Due date",
    vehicle_optional: "Vehicle (optional)",
    vehicle_vin_search_placeholder: "Type the car VIN...",
    vin_required: "Type the VIN first",
    vin_not_found: "VIN not found in inventory",
    or: "OR",
    none: "—",
    notes: "Notes",
    already_paid: "Already paid",
    payments_for: "Payments on",
    mark_paid: "Mark paid",
    fp_alerts_pending_total: "Floor Plan payment(s) need attention",
    fp_alerts_hint: "Check the Financial tab to mark them paid.",
    fp_alerts_overdue: "Overdue",
    fp_alerts_today: "Due today",
    fp_alerts_tomorrow: "Due tomorrow",
    fp_alerts_go: "Go to Financial",
    more: "more",
    filter_all_makes: "All makes",
    filter_all_models: "All models",
    // Inventory · sort dropdown + analytics strip + days-in-stock badge
    sort_label: "Sort",
    sort_make_az: "Make A-Z",
    sort_newest: "Newest",
    sort_oldest: "Longest sitting",
    sort_price_desc: "Price: high to low",
    sort_price_asc: "Price: low to high",
    inv_summary_total: "cars",
    inv_summary_avg_price: "avg price",
    inv_summary_avg_age: "avg age",
    inv_summary_aging: "sitting 60+ days",
    inv_summary_aging_click: "click to filter",
    inv_badge_days: "d",
    inv_filter_aging_active: "Aging only (60+ days)",
    financial_jump_current: "Current month",
    detailed_report_btn: "Detailed report",
    detailed_report_generated: "Report generated — check your downloads",
    filter_all_bodies: "All body types",
    active_filters: "Active filters",
    clear_filters: "Clear filters",
    customers_tab: "Customers",
    customers_eyebrow: "Buyer database",
    customers_title: "Store customers",
    customers_total: "Total customers",
    customers_repeat: "Returning customers",
    customers_total_revenue: "Total revenue",
    customers_search_placeholder: "Search by name, phone or vehicle...",
    customers_no_yet: "No customers yet. Buyers show up here after the first sale.",
    customers_no_match: "No customers found.",
    last_purchase: "Last purchase:",
    repeat_customer_badge: "★ Repeat",
    total_spent: "Total spent",
    vehicles_purchased: "Vehicles purchased",
    served_by: "Served by:",
    vehicle_one: "vehicle",
    import_inv_btn: "Import page",
    import_inv_eyebrow: "Import inventory page",
    import_inv_title: "Import entire inventory",
    import_inv_intro: "Paste the inventory page URL (e.g. /inventory). We'll list every car found and you pick which ones to import at once.",
    import_inv_scan_btn: "List cars",
    import_inv_scanning: "Scanning...",
    import_inv_none: "No cars found on that page. Check the URL.",
    import_inv_select_at_least_one: "Select at least one car.",
    import_inv_selected: "selected",
    import_inv_importing: "Importing...",
    import_inv_done: "{n} car(s) imported successfully!",
    import_inv_errors: "{n} car(s) failed to import.",
    import_inv_skipped: "{n} already in inventory (duplicate VIN) — skipped.",
    import_inv_import_btn: "Import {n} selected",
    import_inv_keep_open: "Back",
    select_all: "Select all",
    deselect_all: "Deselect all",
    errors: "errors",
    close: "Close",
    maintenance_tab: "Maintenance",
    post_sales_tab: "Post-Sales",
    applications_tab: "Applications",
    maintenance_eyebrow: "Yard · Parts · Shop",
    maintenance_title: "Vehicle maintenance",
    maintenance_total_cars: "Vehicles",
    maintenance_total_services: "Services done",
    maintenance_total_cost: "Total maintenance cost",
    maintenance_total_cost_short: "Total cost",
    maintenance_search_placeholder: "Search by make, model, year or VIN...",
    maintenance_no_vehicles: "No vehicles yet.",
    maintenance_no_match: "No vehicles found.",
    maintenance_services: "Logged services",
    maintenance_services_count: "Services",
    maintenance_no_services_yet: "No services logged for this vehicle yet.",
    maintenance_add_service: "New service",
    maintenance_edit_service: "Edit service",
    maintenance_description_placeholder: "Ex: Oil change + filter, alignment, headlight repair...",
    maintenance_parts_optional: "Parts used (one per line · optional)",
    maintenance_parts_placeholder: "Oil 5W30\nOil filter\nBrake pads",
    maintenance_attachments: "Receipt / photos",
    maintenance_attach_hint: "Click to attach receipt or service photo",
    maintenance_confirm_delete: "Delete this service? The cost will be removed automatically from the vehicle.",
    by: "by",
    parts: "Parts",
    file: "File",
    description: "Description",
    amount: "Amount",
    date: "Date",
    loading: "Loading...",
  },
  es: {
    app_name: "Intercar Manager",
    tagline: "Gestión completa para tu concesionaria",
    welcome_back: "Bienvenido de vuelta",
    create_account_title: "Crea tu cuenta y concesionaria",
    auth_hero_line1: "Impulsa",
    auth_hero_line2: "tu concesionaria",
    auth_hero_line3: "al siguiente nivel.",
    auth_hero_blurb: "Inventario, ventas, leads, finanzas y equipo — todo en un solo lugar, en tiempo real.",
    auth_live_status: "Sistema en línea",
    auth_eyebrow_login: "Acceso restringido",
    auth_eyebrow_signup: "Nueva cuenta",
    management_suite: "Suite de gestión",
    show: "Ver",
    hide: "Ocultar",
    or: "o",
    dp_section: "Pago Inicial",
    dp_fully_paid: "Inicial Pagado",
    dp_remaining: "Resta",
    dp_owes: "Resta",
    dp_entrance: "Pago Inicial",
    dp_agreed: "Pago Inicial Acordado",
    dp_paid_so_far: "Pagado",
    dp_balance: "Restante",
    dp_history: "Historial de Pagos",
    dp_no_payments: "No hay pagos registrados aún.",
    dp_add_payment: "Agregar Pago",
    dp_view_history: "Ver Historial",
    dp_amount: "Monto",
    dp_amount_required: "Ingrese un monto mayor a cero",
    dp_payment_saved: "¡Pago registrado y recibo generado!",
    dp_save_and_print: "Guardar e Imprimir Recibo",
    dp_notes_placeholder: "Ej: efectivo, el cliente promete el resto el viernes…",
    dp_all_paid_msg: "El cliente ya pagó el inicial completo. ¡Buen trabajo!",
    missing_purchase_singular: "1 auto sin precio de compra",
    missing_purchase_plural: "autos sin precio de compra",
    missing_purchase_hint: "— complétalo para que el cierre quede correcto. Las filas resaltadas no tienen este valor.",
    missing_purchase_row_hint: "Clic para completar",
    select_option: "Seleccionar...",
    select_bank: "Selecciona el banco...",
    reg_calc_title: "Calculadora MA",
    reg_calc_apply: "Usar",
    reg_calc_applied: "Aplicado",
    reg_calc_sale: "Precio de venta",
    reg_calc_trade_in: "Vehículo en trueque",
    reg_calc_taxable: "Base imponible",
    reg_calc_tax: "Sales tax (6,25%)",
    reg_calc_reg_fee: "Registration fee",
    reg_calc_title_fee: "Title fee",
    reg_calc_runner_fee: "Runner fee",
    reg_calc_total: "Total sugerido",
    funded: "Funded",
    not_funded: "No",
    funded_marked: "FUNDED — el banco pagó",
    funded_undone: "FUNDED removido",
    mark_funded: "Marcar FUNDED — el banco pagó",
    unmark_funded: "Desmarcar FUNDED",
    commission_blocked_until_funded: "Marca FUNDED primero — la comisión solo se paga después del banco",
    theme_auto: "Auto (sigue la tienda)",
    theme_auto_short: "Auto",
    theme_day: "Modo día (claro)",
    theme_day_short: "Día",
    theme_night: "Modo noche (oscuro)",
    theme_night_short: "Noche",
    reg_in_price_label: "Incluir en el precio del auto",
    reg_in_price_on_hint: "La tienda absorbió el registro → cuenta como gasto del vehículo.",
    reg_in_price_off_hint: "El cliente paga aparte → no cuenta como gasto (passthrough).",
    full_name: "Nombre completo",
    dealership_name: "Nombre de la concesionaria",
    email: "Email",
    password: "Contraseña",
    sign_in: "Iniciar sesión",
    create_account: "Crear cuenta",
    no_account: "¿No tienes cuenta? Crea una",
    have_account: "¿Ya tienes cuenta? Inicia sesión",
    dashboard: "Panel",
    inventory: "Inventario",
    sales: "Ventas",
    financials: "Finanzas",
    settings: "Ajustes",
    sign_out: "Cerrar sesión",
    overview: "Resumen",
    total_vehicles: "Total de vehículos",
    in_stock: "En stock",
    reserved: "Reservado",
    sold: "Vendido",
    on_display: "En exhibición",
    open_deals_title: "Negocios en curso",
    open_deals_subtitle: "Vendidos · esperando entrega",
    open_deals_empty: "Sin negocios en curso.",
    pipeline_top_sellers_eyebrow: "Top vendedores",
    pipeline_month_revenue: "Ingresos del mes",
    pipeline_deals_closed_eyebrow: "Cerrados",
    pipeline_deals_closed: "cerrados",
    pipeline_deal: "deal",
    pipeline_deals: "deals",
    pipeline_leaderboard_empty: "Aún no hay ventas cerradas este mes.",
    pipeline_velocity_eyebrow: "Pulso de ventas",
    pipeline_velocity_title: "Últimos 14 días",
    pipeline_this_week: "Esta semana",
    pipeline_vs_prev_week: "vs sem anterior",
    pipeline_today: "Hoy",
    pipeline_week_revenue: "Ingresos 7d",
    pipeline_open_deals_short: "Abiertos",
    pipeline_prev_week: "Sem anterior",
    pipeline_kpi_open_deals: "Negocios abiertos",
    pipeline_kpi_revenue: "Ingresos previstos",
    pipeline_kpi_entrada_paid: "Anticipos recibidos",
    pipeline_kpi_entrada_due: "Anticipos pendientes",
    deal_days_open_hint: "Días desde la venta",
    deal_stale_hint: "Negocio detenido hace mucho — pídele estado al vendedor o llama al banco",
    pipeline_kpi_stale: "Detenidos >20d",
    stale_kpi_hint: "Clic para filtrar",
    stale_filter_active: "Filtro activo",
    stale_filter_label: "Filtrar:",
    stale_filter_all: "Todos",
    stale_filter_20: "Detenidos >20d",
    stale_filter_30: "Críticos >30d",
    stale_view_20: "Negocios detenidos por más de 20 días",
    stale_view_30: "Negocios críticos · más de 30 días detenidos",
    stale_empty_good_news: "¡Buenas noticias! Ningún negocio detenido en ese rango.",
    clear_filters: "Limpiar",
    commission_paid: "Pagada",
    commission_pending: "Pendiente",
    available: "Disponible",
    delivery_view_active: "Activos",
    delivery_view_delivered: "Entregados",
    delivered_this_month: "Entregados este mes",
    avg_delivery_days: "Tiempo medio (días)",
    pending_deliveries: "Pendientes",
    post_sales_from_delivered: "Ticket de coche entregado",
    post_sales_pick_delivered_title: "Selecciona el coche entregado",
    post_sales_pick_delivered_subtitle: "Haz clic en un coche y el ticket se crea con los datos prerellenados.",
    post_sales_no_delivered: "Aún no hay coches entregados.",
    invested: "Invertido en stock",
    revenue: "Ingresos totales",
    profit: "Beneficio total",
    avg_ticket: "Ticket promedio",
    monthly_performance: "Rendimiento mensual",
    months_short: "meses",
    leads_title: "Leads",
    leads_count_label: "leads",
    unassigned_label: "Sin vendedor",
    my_leads: "Mis leads",
    assigned: "Asignado",
    add_lead: "Agregar lead",
    edit_lead: "Editar lead",
    no_leads: "Sin leads en esta vista.",
    search_lead: "Buscar nombre, teléfono, email...",
    contact: "Contacto",
    last_contact: "Último contacto",
    interest_make_model: "Auto de interés",
    budget: "Presupuesto",
    payment_type: "Forma de pago",
    payment_cash: "Contado",
    payment_financing: "Financiamiento",
    claim_lead: "Tomar este lead",
    lead_claimed: "¡Lead asignado!",
    import_monday: "Importar de Monday",
    confirm_monday_import: "¿Importar/actualizar leads de Monday?",
    imported: "Importados",
    updated: "Actualizados",
    total: "Total",
    bdc_users_title: "Usuarios BDC",
    bdc_users_hint: "BDC solo ve el panel y la pestaña Leads. Crea, edita y asigna leads a vendedores.",
    add_bdc: "Agregar BDC",
    no_bdc_users: "Sin usuarios BDC aún.",
    team_title: "Equipo",
    team_hint: "Agrega vendedores y BDCs y elige qué puede ver cada uno.",
    add_team_member: "Agregar persona",
    edit_team_member: "Editar persona",
    no_team_members: "Sin personas aún.",
    role: "Cargo",
    permissions_label: "Permisos",
    permissions_hint: "Marca las áreas que esta persona puede acceder. Puedes cambiar en cualquier momento.",
    link_salesperson: "Vincular a vendedor existente",
    select_salesperson: "Selecciona un vendedor",
    no_available_salesperson: "Todos los vendedores ya tienen acceso. Crea uno nuevo primero.",
    must_pick_salesperson: "Selecciona el vendedor de este acceso.",
    leave_blank_to_keep: "deja en blanco para mantener",
    change_photo: "Cambiar foto",
    team_photo_hint: "Haz clic en la foto para subir una imagen desde tu ordenador (opcional).",
    owner_role: "Dueño",
    owner_role_hint: "El dueño tiene acceso total — no hace falta marcar permisos.",
    owner_full_access_note: "Acceso total — ve todo en el sistema.",
    self_badge: "(tú)",
    manager: "Gerente",
    general_role: "General",
    fi_role: "F&I",
    lead_status_new: "Nuevo",
    lead_status_in_progress: "En progreso",
    lead_status_hot_lead: "Hot lead",
    lead_status_follow_up: "Follow-up",
    lead_status_cold: "Frío",
    lead_status_no_answer: "No contestó",
    lead_status_wrong_number: "Número errado",
    lead_status_deal_closed: "Cerrado",
    lead_status_lost: "Perdido",
    lead_status_future: "Futuro",
    lead_source_facebook: "Facebook",
    lead_source_instagram: "Instagram",
    lead_source_google_ads: "Google Ads",
    lead_source_cargurus: "CarGurus",
    lead_source_carfax: "Carfax",
    lead_source_craigslist: "Craigslist",
    lead_source_walk_in: "Walk-in",
    lead_source_referral: "Referencia",
    lead_source_phone: "Teléfono",
    lead_source_bdc: "BDC",
    lead_source_whatsapp: "WhatsApp",
    lead_source_marketplace: "Marketplace",
    lead_source_tiktok: "TikTok",
    lead_source_youtube: "YouTube",
    lead_source_repeat_customer: "Cliente antiguo",
    lead_source_website: "Sitio propio",
    lead_source_unknown: "Sin informar",
    lead_source_other: "Otro",
    lead_source_label: "¿Cómo el cliente llegó a la tienda?",
    lead_source_hint: "Nos ayuda a saber cuál canal de marketing genera más ventas.",
    lead_source_panel_title: "Origen de las ventas",
    lead_source_panel_hint: "De dónde llegaron los clientes que cerraron este mes.",
    lead_source_panel_empty: "Sin ventas con origen registrado este mes.",
    lead_source_top_channel: "Canal top",
    leaderboard_title: "Ranking de vendedores · este mes",
    leaderboard_empty: "Sin ventas todavía este mes.",
    leaderboard_others: "Demás vendedores",
    vendedor_do_mes: "VENDEDOR DEL MES",
    weekly_promo_title: "Promoción de la semana",
    no_promotion: "Sin promoción activa.",
    create_promotion: "Crear promoción",
    promo_image: "Imagen",
    upload_image: "Subir imagen",
    promo_title_placeholder: "Ej: Viernes de descuentos",
    promo_desc_placeholder: "Detalles, valores, condiciones...",
    valid_until: "Válida hasta",
    optional: "opcional",
    title: "Título",
    description: "Descripción",
    add_vehicle: "Agregar vehículo",
    import_from_url: "Importar por URL",
    paste_url: "Pega la URL del coche de tu sitio",
    import: "Importar",
    importing: "Importando...",
    import_success: "¡Datos importados! Revisa y guarda.",
    import_failed: "No pude importar de esta URL.",
    edit: "Editar",
    delete: "Eliminar",
    save: "Guardar",
    cancel: "Cancelar",
    search: "Buscar...",
    make: "Marca",
    model: "Modelo",
    year: "Año",
    color: "Color",
    vin: "VIN Number",
    purchase_price: "Precio de compra",
    sale_price: "Precio de venta",
    expenses: "Gastos",
    expenses_total: "Total de gastos",
    expense_items: "Desglose de gastos",
    add_expense: "Agregar gasto",
    expense_description: "Descripción del gasto",
    expense_amount: "Importe",
    expense_category: "Categoría",
    expense_date: "Fecha",
    expense_attachments: "Facturas / comprobantes",
    expense_no_items: "Sin gastos aún. ¡Agrega el primero!",
    cat_parts: "Piezas",
    cat_labor: "Mano de obra",
    cat_paint: "Pintura/carrocería",
    cat_documentation: "Documentación",
    cat_transport: "Transporte/grúa",
    cat_detail: "Limpieza/detallado",
    cat_inspection: "Inspección",
    cat_other: "Otros",
    real_profit: "Beneficio real estimado",
    upload_invoice: "Adjuntar factura/foto",
    salespeople: "Vendedores",
    salesperson: "Vendedor",
    select_salesperson: "Selecciona vendedor",
    add_salesperson: "Agregar vendedor",
    salesperson_name: "Nombre",
    commission_amount: "Comisión ($)",
    commission_paid: "Pagado",
    commission_pending: "Pendiente",
    mark_paid: "Marcar como pagado",
    mark_unpaid: "Marcar como pendiente",
    paid: "Pagado",
    pending: "Pendiente",
    phone: "Teléfono",
    active: "Activo",
    inactive: "Inactivo",
    no_salespeople: "Sin vendedores aún.",
    financial: "Financiero",
    financial_dashboard: "Panel financiero",
    monthly_closing: "Cierre mensual",
    gross_profit: "Ganancia autos",
    operational_expenses: "Gastos operacionales",
    operational_total: "Total gastos",
    paid_commissions: "Comisiones pagadas",
    net_profit: "Ganancia neta",
    cars_sold_in_month: "Autos vendidos del mes",
    all_sold_cars: "Todos los autos vendidos",
    buyer_dob: "Cumpleaños del cliente",
    notif_birthdays: "Cumpleaños de clientes",
    notif_assigned_leads: "Leads asignados a ti",
    notif_stale_leads: "Leads sin respuesta del vendedor (+24h)",
    no_response_label: "sin respuesta",
    daily_summary_btn: "Resumen del día",
    inventory_search_placeholder: "Buscar auto, VIN, placa, año o cliente...",
    rec_search_placeholder: "Buscar por cliente, teléfono, auto o VIN...",
    sold_search_placeholder: "Buscar por nombre del cliente, VIN o auto...",
    results_label: "resultado(s)",
    sold_search_empty: "No se encontraron ventas para esta búsqueda",
    view_expenses: "Ver gastos",
    revert_to_stock: "Volver al stock",
    revert_sale_hint: "¿El cliente desistió? Devuelve el auto al stock y borra los datos de venta (comprador, precio, vendedor, comisión, entrega).",
    confirm_revert_sale: "¿Seguro? El auto vuelve al stock y los datos de venta (comprador, vendedor, comisión, etapa de entrega) serán borrados. Los gastos y el precio de compra se mantienen.",
    returned_to_stock: "¡Auto devuelto al stock!",
    lost_sale_title: "¿Por qué cayó la venta?",
    lost_sale_hint: "Selecciona el motivo. Aparecerá en el reporte Financiero para que sigas las pérdidas.",
    lost_reason: "Motivo",
    notes: "Observación",
    lost_notes_placeholder: "Detalle extra (opcional)",
    confirm: "Confirmar",
    lost_sales_title: "Ventas caídas",
    lost_revenue: "Ingresos perdidos",
    reason_financing_denied: "Financiamiento rechazado",
    reason_client_changed_mind: "Cliente desistió",
    reason_mechanical_issue: "Problema mecánico",
    reason_price_disagreement: "No cerró el precio",
    reason_found_better_deal: "Encontró mejor oferta",
    reason_other: "Otro",
    add_expense: "Agregar gasto",
    expense_date: "Fecha",
    expense_category: "Categoría",
    expense_description: "Descripción",
    expense_amount: "Monto",
    expense_attachment: "Recibo",
    no_expenses: "Sin gastos registrados este mes.",
    cat_rent: "Alquiler",
    cat_water: "Agua",
    cat_electricity: "Luz",
    cat_internet: "Internet",
    cat_phone: "Teléfono",
    cat_salary: "Salarios",
    cat_marketing: "Marketing",
    cat_maintenance: "Mantenimiento",
    cat_taxes: "Impuestos",
    cat_floor_plan: "Floor Plan",
    cat_post_sale: "Postventa",
    cat_fi_commission: "Comisión F&I",
    cat_other: "Otros",
    operational_credits: "Créditos operacionales",
    add_credit: "Agregar crédito",
    edit_credit: "Editar crédito",
    no_credits: "Sin créditos este mes.",
    net_operational: "Neto operacional",
    credit_cat_sublease: "Subarrendo",
    credit_cat_refund: "Reembolso",
    credit_cat_commission: "Comisión recibida",
    credit_cat_other: "Otros créditos",
    credit_cat_receivable_payment: "Cuota cobrada",
    credit_auto: "Auto",
    credit_auto_tooltip: "Crédito generado automáticamente por una cuota cobrada en Cuentas por cobrar",
    credit_managed_in_receivables: "En Cuentas por cobrar",
    // Receivables
    receivables_tab: "Cuentas por cobrar",
    receivables_title: "Cuentas por cobrar",
    receivables_eyebrow: "Cobros y planes de pago",
    rec_add: "Nueva cuenta por cobrar",
    rec_edit: "Editar cuenta",
    rec_vehicle: "Vehículo",
    rec_pick_vehicle: "Elegir un vehículo",
    rec_no_vehicle: "Sin vehículo (cliente suelto)",
    rec_no_vehicle_short: "Cliente suelto",
    rec_print_schedule: "Imprimir cronograma para el cliente",
    rec_freq_change_warning: "Las fechas de las cuotas pendientes serán recalculadas con la nueva frecuencia. Las ya pagadas quedan intactas.",
    rec_installment_amount_hint: "Aplicado solo a las cuotas pendientes. Las ya pagadas quedan intactas.",
    // ---------- Defer to next month ----------
    defer_col_hint: "Aplazar al próximo mes",
    move_store_btn: "Cambiar tienda del auto (el vendedor sigue igual)",
    move_store_title: "Mover cierre a",
    move_store_keep_seller: "El vendedor sigue siendo el mismo — solo cambia la tienda donde el auto cuenta en el cierre (recibos y cuentas por cobrar se mueven junto).",
    move_store_done: "Auto movido — vendedor mantenido",
    fund_override_confirm: "Usted es el DUEÑO — ¿liberar el FUNDED de todos modos? (ej.: entrada financiada directo con el cliente — quedará registrado)",
    defer_to_next_month_tooltip: "Aplazar este auto al cierre del próximo mes",
    defer_undo_tooltip: "Restaurar este auto al mes actual",
    defer_confirm: "¿Aplazar este auto al próximo cierre? Saldrá del mes actual (ganancia, comisiones y comisión F&I).",
    defer_undo_confirm: "¿Restaurar este auto al mes actual?",
    defer_done: "Auto aplazado al próximo mes",
    defer_undone: "Auto restaurado al mes actual",
    deferred_to_label: "Aplazado a",
    delivered_in_month_label: "Entregado en",
    delivered_auto_migrate_hint: "Migrado automáticamente al mes de entrega",
    delivered_label: "Entregado",
    delivered_on: "Entregado el",
    // ---------- F&I Officer ----------
    fi_title: "F&I Officer (Finanzas y Seguros)",
    fi_subtitle: "Registra al responsable del cierre de financiamientos. El sistema registra automáticamente un gasto de comisión cada vez que un auto pasa a FUNDED.",
    fi_photo: "Foto",
    fi_photo_uploaded: "Foto actualizada",
    fi_name: "Nombre completo",
    fi_name_placeholder: "Ej: John Smith",
    fi_weekly_salary: "Sueldo semanal (US$)",
    fi_commission_per_funded: "Comisión por auto funded (US$)",
    fi_pay_weekly: "Pagar sueldo de esta semana",
    fi_week_already_paid: "Semana actual ya pagada",
    fi_remove: "Eliminar F&I",
    fi_remove_confirm: "¿Eliminar al F&I? Los gastos ya registrados permanecen en el historial.",
    fi_legal_note: "La comisión se registra como gasto operativo automáticamente cuando un auto se marca como FUNDED. Si lo des-fundes, el gasto se elimina.",
    fi_month_commissions: "Comisiones este mes",
    fi_this_week_salary: "Sueldo de esta semana",
    fi_last_paid: "Último sueldo pagado",
    fi_paid: "PAGADO",
    fi_pending: "PENDIENTE",
    fi_already_paid_week: "El sueldo de esta semana ya había sido pagado",
    fi_salary_paid: "Sueldo registrado en Financiero",
    removed: "Eliminado",
    payment_auth_btn: "Autorización de Pago",
    payment_auth_pick_lang: "Idioma del documento",
    rec_customer_name: "Nombre del cliente",
    rec_customer_required: "El nombre del cliente es obligatorio",
    rec_phone: "Teléfono",
    rec_total_amount: "Monto total",
    rec_down_payment: "Entrada (opcional)",
    rec_down_payment_short: "Entrada",
    rec_down_payment_hint: "Pagado hoy. Reduce el monto a financiar.",
    rec_down_payment_receipt: "Recibo de entrada",
    purchase_agreement: "Contrato de Venta",
    forgot_password: "Olvidé mi contraseña",
    forgot_title: "Recuperar contraseña",
    forgot_hint: "Escribe tu email y te enviaremos un enlace para restablecer tu contraseña.",
    forgot_send: "Enviar enlace",
    forgot_sent: "Si el email existe, recibirás el enlace en unos instantes. Revisa también el spam.",
    back_to_login: "Volver al login",
    reset_title: "Nueva contraseña",
    reset_hint: "Elige una nueva contraseña para tu cuenta.",
    new_password_label: "Nueva contraseña",
    confirm_password_label: "Confirmar contraseña",
    reset_submit: "Restablecer contraseña",
    reset_success: "¡Contraseña restablecida! Inicia sesión con la nueva.",
    reset_invalid: "Enlace inválido o expirado. Pide uno nuevo.",
    passwords_dont_match: "Las contraseñas no coinciden",
    password_min: "La contraseña necesita al menos 6 caracteres",
    notif_title: "Notificaciones",
    diag_title: "Diagnóstico de la cuenta",
    test_email_btn: "Enviar email de prueba",
    net_check_label: "Net check (financiamiento)",
    send_closing_email: "Enviar cierre por email",
    negotiation_sheet_ready: "Ficha de negociación finalizada",
    open_sheet: "Abrir ficha",
    resend_sale_email: "Reenviar email de venta",
    diag_healthy: "¡Todo bien! Ningún problema encontrado en esta cuenta.",
    diag_repair: "Reparar automáticamente",
    diag_repaired: "¡Cuenta reparada!",
    diag_fix_note: "Ítems en rojo sin reparación automática: recrea las credenciales en Equipo o pide que la persona reintente.",
    diag_check_login: "Login y contraseña registrados",
    diag_check_store: "Tienda del usuario",
    diag_check_group: "Vínculo con el grupo de tiendas",
    diag_check_permissions: "Permisos de acceso",
    diag_check_sp_link: "Vínculo con registro de vendedor",
    diag_check_sp_store: "Tienda del login = tienda del vendedor",
    diag_check_duplicates: "Cuentas duplicadas",
    nav_delivery: "Entregas",
    notif_empty: "¡Todo al día! Sin alertas pendientes.",
    notif_rmv: "RMV pendiente",
    notif_stuck: "Entregas paradas +45d",
    notif_overdue: "Cobros atrasados",
    notif_due_today: "Cobros vencen hoy",
    notif_revision_ready: "Listos en revisión",
    notif_new_leads: "Leads nuevos",
    activity_tab: "Actividades",
    activity_title: "Registro de Actividades",
    activity_hint: "Quién hizo qué y cuándo — acciones importantes de tus tiendas.",
    activity_empty: "Ninguna actividad registrada aún.",
    activity_load_more: "Cargar más",
    activity_search: "Buscar por usuario, acción o ítem...",
    act_vehicle_deleted: "eliminó el auto",
    act_vehicle_transferred: "transfirió el auto",
    act_vehicle_funded: "marcó FUNDED:",
    act_vehicle_unfunded: "desmarcó FUNDED:",
    act_sale_corrected: "corrigió valores de venta:",
    act_expense_created: "registró el gasto",
    act_expense_deleted: "eliminó el gasto",
    act_receivable_deleted: "eliminó el cobro de",
    act_team_member_deleted: "eliminó del equipo:",
    act_salesperson_transferred: "transfirió al vendedor",
    bank_other_option: "Otro banco (escribir)...",
    bank_other_placeholder: "Escribe el nombre del banco nuevo...",
    finance_term: "Cant. de cuotas",
    finance_installment: "Valor de la cuota (US$)",
    warranty_months_label: "Garantía (meses)",
    payment_frequency_label: "Frecuencia de pago",
    freq_monthly: "Mensual",
    freq_weekly: "Semanal",
    doc_fee_included: "DOC FEE US$ 499.00 — incluido en todo financiamiento (sale especificado en el contrato)",
    doc_fee_charge: "Cobrar Doc Fee (US$ 499.00)",
    doc_fee_hint: "Elige si el doc fee se cobra en esta venta al contado — sale directo en el contrato.",
    doc_fee_yes: "Cobrar US$ 499",
    doc_fee_no: "No cobrar (descuento)",
    doc_fee_mandatory: "Obligatorio en todo financiamiento — sale automático en el contrato.",
    contract_edit_title: "Contrato de Venta — revisar antes de imprimir",
    contract_edit_hint: "Los cambios hechos aquí valen SOLO para este PDF — no cambian el cierre ni los datos del auto.",
    contract_generate: "Generar PDF del contrato",
    rate_label: "Tasa (Rate %)",
    referral_label: "Referral / Origen",
    trade_in_title: "Vehículo en la permuta",
    trade_in_value: "Avaluación",
    payoff: "Payoff",
    payoff_bank: "Banco del payoff",
    vex_fix_values: "Corregir valores (solo dueño)",
    vex_fix_save: "Guardar corrección",
    vex_fix_saved: "Valores corregidos",
    vex_fix_hint: "Corrección del dueño: ajusta directamente el cierre. Queda registrado en el historial del auto.",
    rec_down_payment_paid_on: "Entrada recibida el",
    rec_total: "Total",
    rec_paid: "Pagado",
    rec_remaining: "Restante",
    rec_frequency: "Frecuencia",
    rec_freq_weekly: "Semanal",
    rec_freq_biweekly: "Quincenal",
    rec_freq_monthly: "Mensual",
    rec_installment_count: "Nº de cuotas",
    rec_installment_amount: "Valor de la cuota",
    rec_installments: "cuotas",
    rec_start_date: "Fecha 1ª cuota",
    rec_due_date: "Vencimiento",
    rec_amount: "Valor",
    rec_status: "Estado",
    rec_status_active: "Activo",
    rec_status_completed: "Pagado",
    rec_status_cancelled: "Cancelado",
    rec_filter_all: "Todos",
    rec_paid_at: "Pagado el",
    rec_paid_label: "Pagado",
    rec_pending: "Pendiente",
    rec_mark_paid: "Marcar pagado",
    rec_marked_paid: "¡Cuota pagada!",
    rec_undo_paid: "Deshacer",
    rec_confirm_unpay: "¿Seguro que quieres revertir este pago?",
    rec_total_remaining: "Total por cobrar",
    rec_overdue: "Vencidas",
    rec_due_today: "Vence hoy",
    rec_due_week: "Próx. 7 días",
    rec_paid_this_month: "Cobrado en el mes",
    rec_reminders: "Recordatorios de cobro",
    rec_empty: "Sin cuentas por cobrar.",
    rec_notes: "Notas",
    rec_preview_schedule: "Vista previa",
    rec_more: "más",
    rec_overview_card: "Por cobrar",
    rec_overview_overdue: "vencidas",
    rec_edit_due_date: "Editar fecha",
    rec_edit_propagate: "Aplicar a las próximas",
    delivered_archive_eyebrow: "Archivo de entregas",
    delivered_archive_title: "Vendidos & Entregados",
    delivered_archive_count: "autos entregados",
    delivered_archive_current: "Mes actual",
    delivered_trend_title: "Entregas · Últimos 6 meses",
    delivered_trend_vs_prev: "vs. mes anterior",
    delivered_archive_export_pdf: "Exportar PDF del mes",
    expand: "Expandir",
    collapse: "Contraer",
    // Sale finalization
    mark_as_sold: "Marcar como vendido",
    sale_finalize: "Finalizar venta",
    sale_breakdown: "Detalle del cobro",
    down_payment: "Entrada",
    bank_check_amount: "Cheque del banco",
    registration_cost: "Registro / Patente",
    registration_cost_hint: "Cuánto vas a gastar para registrar este vehículo",
    final_sold_price: "Valor de venta",
    asking_price: "Precio pedido",
    difference: "Diferencia",
    over_asking: "sobre el pedido",
    under_asking: "bajo el pedido",
    cat_registration: "Patente",
    rec_reminder_title: "Recordatorio de cobro",
    rec_alert_dismiss: "OK, después",
    rec_alert_open: "Ver cuentas por cobrar",
    push_enabled: "¡Notificaciones activadas!",
    push_disabled: "Notificaciones desactivadas.",
    push_enable_hint: "Recibe alertas en tu móvil cuando vendan un coche",
    push_disable_hint: "Desactivar notificaciones",
    push_permission_denied: "Permiso denegado. Habilítalo en la configuración del navegador.",
    push_not_supported: "Tu navegador no admite notificaciones push.",
    select_month: "Selecciona el mes",
    set_login: "Definir acceso",
    edit_login: "Editar acceso",
    revoke_login: "Eliminar acceso",
    has_login: "Tiene acceso",
    no_login: "Sin acceso",
    login_email: "Email de acceso",
    new_password: "Nueva contraseña",
    salesperson_login_hint: "El vendedor podrá entrar con este email y contraseña. NO verá cuánto pagaste por el auto ni las ganancias.",
    confirm_revoke_login: "¿Eliminar el acceso de este vendedor? No podrá acceder más a la app.",
    sales_report: "Informe de ventas",
    period: "Período",
    all_time: "Todo el tiempo",
    this_month: "Este mes",
    last_month: "Mes pasado",
    by_salesperson: "Por vendedor",
    detailed_sales: "Ventas detalladas",
    sales_count: "Ventas",
    total_revenue: "Ingresos totales",
    total_commission: "Comisión total",
    day_of_month: "Día",
    sale_date: "Fecha de venta",
    unassigned: "Sin asignar",
    change_salesperson: "Cambiar vendedor",
    description: "Descripción",
    images: "Fotos del vehículo",
    status: "Estado",
    transmission: "Transmisión",
    fuel_type: "Combustible",
    body_type: "Carrocería",
    buyer_name: "Nombre del comprador",
    buyer_phone: "Teléfono del comprador",
    buyer_email: "Email del comprador",
    buyer_address: "Dirección del comprador",
    payment_method: "Forma de pago",
    sold_price: "Precio final vendido",
    no_vehicles: "Aún no hay vehículos.",
    confirm_delete: "¿Confirma la eliminación?",
    public_api: "API pública",
    api_description: "Usa este endpoint en tu sitio externo para extraer el inventario automáticamente.",
    api_token: "Token de API",
    regenerate: "Generar nuevo token",
    copy: "Copiar",
    copied: "¡Copiado!",
    profit_per_vehicle: "Beneficio por vehículo",
    cost: "Costo",
    sold_at: "Vendido en",
    move_to: "Mover a",
    saved: "¡Guardado!",
    error_generic: "Algo salió mal.",
    invalid_credentials: "Email o contraseña inválidos",
    email_in_use: "Email ya registrado",
    pipeline: "Pipeline de ventas",
    finalize_sale: "Finalizar venta",
    delivery: "Pipeline de entrega",
    delivery_pipeline_title: "Entrega de Vehículos",
    edit_step: "Editar etapa",
    advance_step: "Avanzar etapa",
    back_step: "Volver etapa",
    notes: "Notas",
    bank: "Banco",
    delivery_notes: "Notas de entrega",
    no_deliveries: "Ningún vehículo en entrega ahora.",
    delivered_section_title: "Ya entregados",
    delivered_section_one: "auto entregado",
    delivered_section_many: "autos entregados",
    delivered_label: "Entregado",
    reopen_delivery: "Reabrir entrega",
    reopen_delivery_confirm: "Reabrir esta entrega? El auto volverá al paso 7 (Registro) y se limpiará la fecha de entrega.",
    delivery_reopened: "Entrega reabierta — el auto volvió al paso 7",
    no_stuck_deliveries: "No hay coches atascados ahora.",
    stuck_alert_title_one: "coche atascado más de 45 días",
    stuck_alert_title_many: "coches atascados más de 45 días",
    stuck_alert_hint: "Revisa — alguna etapa está trabada y la entrega no avanza.",
    stuck_days_chip: "Atascado hace {d} días",
    show_only_stuck: "Ver solo atascados",
    show_all: "Ver todos",
    step_1: "Vendido",
    step_2: "Ficha de negociación + Recibo",
    bank_contract_short: "Contrato",
    bank_contract_signed_on: "Contrato del banco firmado",
    bank_contract_pending: "Marcar contrato del banco como firmado",
    bank_contract_marked: "¡Contrato marcado como firmado!",
    bank_contract_unmarked: "Marca de contrato eliminada.",
    receipts: "Recibos",
    new_receipt: "Nuevo recibo",
    no_receipts_yet: "Sin recibos emitidos.",
    receipt_amount: "Valor del depósito",
    receipt_amount_required: "Ingresa el valor del depósito",
    receipt_created: "¡Recibo creado!",
    non_refundable_amount: "Monto no reembolsable",
    create_and_print: "Crear e imprimir",
    address: "Dirección",
    open_pdf: "Abrir PDF",
    step_3: "Documentaciones",
    doc_drive: "Licencia de Conducir",
    doc_insurance: "Seguro",
    doc_income: "Comprobante de Ingresos",
    doc_address: "Comprobante de Domicilio",
    doc_other: "Otros documentos",
    doc_uploaded: "documento(s)",
    doc_no_files_yet: "Ningún archivo aquí todavía — haz clic para agregar.",
    doc_add_file: "Agregar archivo",
    // Parts notes block on the Overview dashboard
    parts_notes_title: "Piezas para Comprar",
    parts_notes_eyebrow: "Bloque de Notas",
    parts_notes_subtitle: "Anota las piezas que necesitas comprar y los recordatorios del taller",
    parts_notes_scratch_label: "Notas",
    parts_notes_scratch_placeholder: "Escribe libremente — códigos de piezas, proveedores, recordatorios…",
    parts_notes_list_label: "Lista de piezas",
    parts_notes_list_placeholder: "Ej: Pastillas de freno delanteras · Civic 2018",
    parts_notes_add: "Agregar pieza",
    parts_notes_empty: "Aún no hay ítems. Agrega tu primera pieza arriba.",
    parts_notes_pending: "pendiente(s)",
    parts_notes_done: "completada(s)",
    parts_notes_save: "Guardar notas",
    parts_notes_saved: "Notas guardadas",
    parts_notes_last_update: "Actualizado por",
    parts_notes_manager_only: "Solo gerentes pueden editar",
    // Revision status badge on delivery cards
    revision_badge_in_shop: "REVISIÓN: EN TALLER",
    revision_badge_ready: "REVISIÓN: LISTA",
    revision_badge_pending: "REVISIÓN: PENDIENTE",
    // WhatsApp quick-contact messages (wa.me deep-link)
    wa_button_label: "WhatsApp",
    wa_delivery_message: "¡Hola {name}! Aviso rápido sobre tu {vehicle}. Ahora está en la etapa: {step}. Cualquier duda me avisas.",
    wa_revision_ready_message: "¡Hola {name}! Buena noticia: tu {vehicle} acaba de salir del taller y está listo para recoger. ¿Coordinamos un horario?",
    wa_delivered_message: "¡Hola {name}! Gracias por elegirnos con tu {vehicle}. Cualquier cosa que necesites, escríbeme.",
    vex_add_post_sale: "Agregar gasto post-venta",
    post_sale_desc_placeholder: "Ej: Cambio de pastillas de freno",
    step_4: "Mantenimiento",
    step_5: "Seguro",
    step_6: "Título recibido",
    step_7: "Registro",
    step_8: "Entregado",
    save_step: "Guardar etapa",
    bank_name_label: "Nombre del banco",
    delivered: "Entregado",
    in_progress: "En progreso",
    no_photo: "Sin foto",
    files: "Archivos",
    upload_file: "Subir archivo",
    upload_for_step: "Adjuntar archivos · Etapa",
    drag_drop: "Arrastra archivos aquí o haz clic para seleccionar",
    no_files_yet: "Aún no hay archivos en esta etapa.",
    file_too_large: "Archivo demasiado grande (máx 20MB)",
    download: "Descargar",
    view: "Ver",
    step_notes_label: "Notas de esta etapa",
    step_notes_placeholder: "Ej: Cliente pidió cambio de pastillas de freno y rotación de neumáticos...",
    save_notes: "Guardar notas",
    delivery_photos: "Fotos de entrega",
    delivery_photos_hint: "Sube todas las fotos del coche en el momento de la entrega (exterior, interior, odómetro, documentos, etc.). Sin límite de cantidad.",
    photos_count: "fotos",
    photos_imported: "fotos importadas — todas se guardarán",
    vehicle_history: "Historial",
    close_month_btn: "Cerrar mes",
    close_month_title: "Cerrar y exportar",
    close_month_intro: "El cierre solo cuenta autos ya FUNDADOS por el banco en el mes. Ventas sin funding quedan abiertas y entran al próximo mes.",
    closing_funded_vehicles: "Vehículos fundados",
    credits_total: "Créditos operacionales",
    closing_receivables_received: "Cobros recibidos",
    purchase_missing_badge: "Sin precio",
    purchase_missing_hint: "Precio de compra no completado — la ganancia real está sobreestimada. Clic en el valor para editar.",
    purchase_missing_count: "sin precio de compra",
    notifications_title: "Notificaciones por email",
    notifications_description: "Recibe un aviso corto en tu inbox cada vez que ocurra algo importante. Va a ti (dueño) y a todos los gerentes.",
    notifications_team_events_title: "Notificaciones al equipo",
    notifications_team_events_hint: "Cuando está ON, envía emails a ti y a los gerentes en cada evento abajo:",
    notifications_status_on: "Notificaciones activadas",
    notifications_status_off: "Notificaciones desactivadas",
    notif_event_sold: "Auto vendido",
    notif_event_funded: "Auto fundado por el banco",
    notif_event_delivered: "Auto entregado al cliente",
    notif_event_application: "Nueva aplicación de crédito",
    notif_event_down_payment: "Anticipo (down payment) registrado",
    notif_event_installment: "Cuota de recibible pagada",
    notif_event_lead: "Nuevo lead creado",
    fp_inventory_eyebrow: "Búsqueda rápida",
    fp_inventory_title: "Inventario por Floor Plan",
    fp_inventory_units: "autos financiados",
    fp_inventory_title_pending: "títulos pendientes",
    fp_inventory_title_pending_short: "título",
    fp_inventory_title_pending_section: "Título pendiente · vendidos sin funding",
    fp_inventory_on_lot_section: "En el lote",
    fp_inventory_search_placeholder: "Buscar por auto, VIN, comprador, stock #...",
    fp_inventory_no_plans: "Crea un floor plan primero para organizar el inventario.",
    fp_inventory_no_matches: "Ningún auto en esa búsqueda.",
    fp_inventory_empty_plan: "Aún no hay autos asignados a este floor plan.",
    fp_inventory_orphans_title: "Sin floor plan",
    fp_inventory_orphans_hint: "autos sin pagos vinculados",
    fp_on_lot_short: "en lote",
    fp_pending_short: "título pend.",
    floor_plan_label: "Floor Plan",
    floor_plan_hint: "de dónde vino el auto (para pedir el título)",
    floor_plan_none: "Sin floor plan",
    floor_plan_no_plans_hint: "Crea un floor plan en Financiero → Floor Plans.",
    closing_open_deals_title: "Negocios abiertos",
    closing_open_deals_hint: "Estos autos se vendieron pero el banco aún no los fundó — entrarán automáticamente al cierre del próximo mes.",
    close_month_success: "Mes cerrado y PDF descargado!",
    close_and_export: "Cerrar y descargar PDF",
    closings_archive_title: "Carpeta de cierres",
    closings_archive_empty: "Ningún mes cerrado aún. Usa el botón \"Cerrar mes\" arriba para generar el primer PDF.",
    closing_one: "cierre archivado",
    closing_many: "cierres archivados",
    closings_confirm_delete: "¿Eliminar este cierre? El PDF también se quitará.",
    closed_at: "Cerrado el",
    vehicles: "Vehículos",
    vehicles_sold_label: "Vehículos vendidos",
    mark_commissions_paid_label: "Marcar todas las comisiones del mes como pagadas",
    mark_commissions_paid_hint: "Útil cuando realmente pagaste a los vendedores al fin de mes — se registra en el historial de cada vehículo.",
    download: "Descargar",
    change_password_link: "Cambiar contraseña",
    change_password_title: "Cambiar mi contraseña",
    change_password_intro: "Define una contraseña personal para mayor seguridad. Mínimo 6 caracteres.",
    change_password_current: "Contraseña actual",
    change_password_new: "Nueva contraseña",
    change_password_confirm: "Confirmar nueva contraseña",
    change_password_show: "Mostrar contraseñas",
    change_password_mismatch: "La confirmación no coincide con la nueva contraseña.",
    change_password_too_short: "La nueva contraseña debe tener al menos 6 caracteres.",
    change_password_success: "¡Contraseña cambiada con éxito!",
    monthly_evolution: "Evolución mensual (últimos 12 cierres)",
    floor_plans_title: "Floor Plans · Calendario de pagos",
    floor_plans_add_plan: "Nuevo plan",
    floor_plans_edit_plan: "Editar plan",
    floor_plans_add_pay: "Nuevo pago",
    floor_plans_edit_pay: "Editar pago",
    floor_plans_empty_plans: "Agrega tus Floor Plans para empezar (NextGear, Westlake, etc).",
    floor_plans_calendar_hint: "Haz clic en un día para ver/agregar pagos.",
    floor_plans_confirm_delete_plan: "¿Eliminar este Floor Plan? Todos los pagos vinculados también se quitarán.",
    floor_plans_confirm_delete_pay: "¿Eliminar este pago?",
    floor_plans_pick_plan_first: "Elige un Floor Plan.",
    floor_plan: "Floor Plan",
    pending: "Pendiente",
    paid: "Pagado",
    month_total: "Total del mes",
    today: "Hoy",
    name: "Nombre",
    color: "Color",
    due_date: "Fecha",
    vehicle_optional: "Vehículo (opcional)",
    vehicle_vin_search_placeholder: "Escribe el VIN del auto...",
    vin_required: "Escribe el VIN primero",
    vin_not_found: "VIN no encontrado en el inventario",
    or: "O",
    none: "—",
    notes: "Notas",
    already_paid: "Ya pagado",
    payments_for: "Pagos del día",
    mark_paid: "Marcar pagado",
    fp_alerts_pending_total: "pago(s) de Floor Plan necesitan atención",
    fp_alerts_hint: "Mira la pestaña Financiero para marcarlos.",
    fp_alerts_overdue: "Atrasados",
    fp_alerts_today: "Vencen hoy",
    fp_alerts_tomorrow: "Vencen mañana",
    fp_alerts_go: "Ir a Financiero",
    more: "más",
    filter_all_makes: "Todas las marcas",
    filter_all_models: "Todos los modelos",
    // Inventario · dropdown de orden + tira analítica + insignia de días
    sort_label: "Ordenar",
    sort_make_az: "Marca A-Z",
    sort_newest: "Más recientes",
    sort_oldest: "Más tiempo parados",
    sort_price_desc: "Precio: mayor",
    sort_price_asc: "Precio: menor",
    inv_summary_total: "autos",
    inv_summary_avg_price: "precio prom.",
    inv_summary_avg_age: "edad prom.",
    inv_summary_aging: "parados +60 días",
    inv_summary_aging_click: "clic para filtrar",
    inv_badge_days: "d",
    inv_filter_aging_active: "Solo aging (60+ días)",
    financial_jump_current: "Mes actual",
    detailed_report_btn: "Reporte detallado",
    detailed_report_generated: "Reporte generado — revisa tus descargas",
    filter_all_bodies: "Todos los tipos",
    active_filters: "Filtros activos",
    clear_filters: "Limpiar filtros",
    customers_tab: "Clientes",
    customers_eyebrow: "Base de compradores",
    customers_title: "Clientes de la tienda",
    customers_total: "Total de clientes",
    customers_repeat: "Clientes que volvieron",
    customers_total_revenue: "Ingresos totales",
    customers_search_placeholder: "Buscar por nombre, teléfono o vehículo...",
    customers_no_yet: "Aún no hay clientes. Los compradores aparecen aquí tras la primera venta.",
    customers_no_match: "No se encontraron clientes.",
    last_purchase: "Última compra:",
    repeat_customer_badge: "★ Recompra",
    total_spent: "Total gastado",
    vehicles_purchased: "Vehículos comprados",
    served_by: "Atendido por:",
    vehicle_one: "vehículo",
    import_inv_btn: "Importar página",
    import_inv_eyebrow: "Importar página de inventario",
    import_inv_title: "Importar inventario entero",
    import_inv_intro: "Pega el enlace de la página de inventario (ej: /inventory). Listamos todos los coches y tú eliges cuáles importar de una vez.",
    import_inv_scan_btn: "Listar coches",
    import_inv_scanning: "Buscando...",
    import_inv_none: "No se encontraron coches en esa página. Verifica la URL.",
    import_inv_select_at_least_one: "Selecciona al menos un coche.",
    import_inv_selected: "seleccionados",
    import_inv_importing: "Importando...",
    import_inv_done: "¡{n} coche(s) importado(s) con éxito!",
    import_inv_errors: "{n} coche(s) fallaron.",
    import_inv_skipped: "{n} ya estaban en inventario (VIN duplicado) — omitidos.",
    import_inv_import_btn: "Importar {n} seleccionados",
    import_inv_keep_open: "Volver",
    select_all: "Seleccionar todo",
    deselect_all: "Limpiar selección",
    errors: "errores",
    close: "Cerrar",
    maintenance_tab: "Mantenimiento",
    post_sales_tab: "Postventa",
    applications_tab: "Solicitudes",
    maintenance_eyebrow: "Patio · Repuestos · Taller",
    maintenance_title: "Mantenimiento de vehículos",
    maintenance_total_cars: "Vehículos",
    maintenance_total_services: "Servicios hechos",
    maintenance_total_cost: "Costo total de mantenimiento",
    maintenance_total_cost_short: "Costo total",
    maintenance_search_placeholder: "Buscar por marca, modelo, año o VIN...",
    maintenance_no_vehicles: "Aún no hay vehículos.",
    maintenance_no_match: "No se encontraron vehículos.",
    maintenance_services: "Servicios registrados",
    maintenance_services_count: "Servicios",
    maintenance_no_services_yet: "Aún no hay servicios para este vehículo.",
    maintenance_add_service: "Nuevo servicio",
    maintenance_edit_service: "Editar servicio",
    maintenance_description_placeholder: "Ej: Cambio de aceite + filtro, alineación, reparación del faro...",
    maintenance_parts_optional: "Repuestos usados (uno por línea · opcional)",
    maintenance_parts_placeholder: "Aceite 5W30\nFiltro de aceite\nPastillas de freno",
    maintenance_attachments: "Factura / fotos",
    maintenance_attach_hint: "Haz clic para adjuntar factura o foto del servicio",
    maintenance_confirm_delete: "¿Eliminar este servicio? El costo se quitará automáticamente del vehículo.",
    by: "por",
    parts: "Repuestos",
    file: "Archivo",
    description: "Descripción",
    amount: "Monto",
    date: "Fecha",
    loading: "Cargando...",
  },
};

import { createContext, useContext, useState } from "react";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("intercar_lang") || "pt");
  const change = (l) => {
    localStorage.setItem("intercar_lang", l);
    setLang(l);
  };
  const t = (key) => TRANSLATIONS[lang]?.[key] || TRANSLATIONS.en[key] || key;
  return <I18nContext.Provider value={{ lang, t, setLang: change }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

export const LANG_OPTIONS = [
  { code: "pt", label: "PT", flag: "🇧🇷" },
  { code: "en", label: "EN", flag: "🇺🇸" },
  { code: "es", label: "ES", flag: "🇪🇸" },
];
